<template>
  <div class="content-wrapper" id="top">
    <ContentHeader
      :title="title"
      :is-create="isCreate"
      :breadcrumbs="breadcrumbs" />

    <section class="content">
      <div class="row" v-if="isLoading">
        <div class="col-md-12 text-center">
          <div class="jumbotron">
            <ProgressLoader />
          </div>
        </div>
      </div>

      <form class="form" id="product_id" @submit.prevent="submit" v-else>
        <div class="row">
          <!-- Left Content -->
          <div id="main-content" class="col col-md-9 col-lg-9">
            <!-- Quickjump -->
            <affix class="quickjump-menu"
              relative-element-selector="#main-content"
              style="width: 800px"
              :offset="{ top: 0, bottom: 10 }">
              <Quickjump :show-klook="isKlook" />
              <div class="flaging-title">
                Product {{capitalizeFirstLetter(params.flaging)}}
              </div>
            </affix>

            <div class="alert need-approval" v-if="status_product === 'Need Approval'">
              <strong class="alert-title">Status {{status_product}}</strong>
              <br>
              <span>Please check data below and respond the product</span>
            </div>

            <div class="alert need-revision" v-if="status_product === 'Need Revision'">
              <strong class="alert-title">Status {{status_product}}</strong>
              <br>
              <span>Waiting merchant partners to update the product</span>
            </div>

            <div class="alert approved" v-if="status_product === 'Approved'">
              <strong class="alert-title">Status {{status_product}}</strong>
              <br><br>
            </div>

            <!-- Product Title -->
            <box id="title" title="Title">
              <tabs>
                <tab name="Indonesia" :selected="true">
                  <input type="text"
                    id="name"
                    class="form-control input-lg strong"
                    placeholder="Product title Indonesia"
                    v-model="form.name"/>
                </tab>

                <tab name="English">
                  <input type="text"
                    id="name_en"
                    class="form-control input-lg strong"
                    placeholder="Product title English"
                    v-model="form.name_en" />
                </tab>
              </tabs>
            </box>

            <!-- Product Details -->
            <box id="details" title="Details">
              <div class="form-horizontal">
                <!-- Region-->
                <div class="form-group">
                  <label for="type"
                    class="control-label col-md-2">
                    Region <span class="req">*</span>
                  </label>

                  <div class="col-md-8">
                    <v-select
                      name="category"
                      placeholder="Select region category"
                      v-model="form.type"
                      :clearable="false"
                      :options="list.region"
                      :class="{ disabled: vselect_disabled }">
                    </v-select>
                  </div>
                </div>

                <!-- Destination -->
                <div class="form-group">
                  <label for="destination"
                    class="control-label col-md-2">
                    Destinations <span class="req">*</span>
                  </label>

                  <div class="col-md-8">
                    <treeselect
                      placeholder="Select destinations"
                      v-model="form.destinations"
                      id="form"
                      ref="destinationOption"
                      :value-consists-of="'ALL_WITH_INDETERMINATE'"
                      :sort-value-by="'LEVEL'"
                      :multiple="true"
                      :options="list.destinations"
                      :default-expand-level="1"
                      :disable-branch-nodes="true"
                      :auto-load-root-options="true"
                      :class="{ disabled: vselect_disabled }">
                    </treeselect>
                    <p class="small help-block m-0">You can only choose one city as destinations. Province and Country. Province and Country will be automatically selected according to the selected city.</p>
                  </div>

                  <div class="col-md-2">
                    <button class="btn btn-info btn-sm"
                      @click.prevent="showModal('destinations')">
                      Add Option
                    </button>
                  </div>
                </div>

                <!-- Category -->
                <div class="form-group">
                  <label for="category"
                    class="control-label col-md-2">
                    Categories <span class="req">*</span>
                  </label>

                  <div class="col-md-8">
                    <v-select multiple
                      name="category"
                      placeholder="Select product category"
                      v-model="form.categories"
                      :options="list.categories"
                      :class="{ disabled: vselect_disabled }">
                    </v-select>
                  </div>

                  <div class="col-md-2">
                    <button class="btn btn-info btn-sm"
                      @click.prevent="showModal('categories')">
                      Add Option
                    </button>
                  </div>
                </div>

                <!-- Tags -->
                <div class="form-group">
                  <label for="tag"
                    class="control-label col-md-2">
                    Tags <span class="req">*</span>
                  </label>

                  <div class="col-md-8">
                    <v-select multiple
                      name="tags"
                      placeholder="Select tags"
                      v-model="form.tags"
                      :options="list.tags"
                      :class="{ disabled: vselect_disabled }">
                    </v-select>
                  </div>
                </div>

                <!-- Basic Condition -->
                <div class="form-group">
                  <label for="type"
                    class="control-label col-md-2">
                    Condition <span class="req">*</span>
                  </label>

                  <div class="col-md-8">
                    <v-select
                      name="condition"
                      placeholder="Select basic condition"
                      v-model="form.condition"
                      :clearable="false"
                      :options="list.condition"
                      :class="{ disabled: vselect_disabled }">
                    </v-select>

                    <!-- <label class="radio-inline">
                      <input type="radio"
                        name="with_adult_is_must"
                        id="with_adult_is_must"
                        v-model="form.with_adult_is_must"
                        :value="0"> No need specific condition
                    </label>
                    <label class="radio-inline">
                      <input type="radio"
                        name="with_adult_is_must"
                        id="with_adult_is_must"
                        v-model="form.with_adult_is_must"
                        :value="1"> With adult is must
                    </label> -->
                  </div>
                </div>

                <!-- Printed -->
                <div class="form-group">
                  <label for="printed"
                    class="control-label col-md-2">
                    Printed
                  </label>

                  <div class="col-md-8">
                    <div class="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          v-model="form.print_voucher">
                        <strong>Print Voucher/Ticket</strong>
                        <p class="small help-block">Ticket/Voucher will not be printed if unchecked.</p>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="type" class="control-label col-md-2">
                    Breadcrumbs
                  </label>
                  <div class="col-md-8">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" v-model="form.hide_breadcrumbs">
                        <strong>Hide Breadcrumbs</strong>
                        <p class="small help-block">Hide from product detail page</p>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="type" class="control-label col-md-2">
                    Searchbar
                  </label>
                  <div class="col-md-8">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" v-model="form.hide_searchbar">
                        <strong>Hide Searchbar</strong>
                        <p class="small help-block">Hide from product detail page</p>
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="type" class="control-label col-md-2">
                    Recommendation
                  </label>
                  <div class="col-md-8">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" v-model="form.hide_recommendation">
                        <strong>Hide Recommendation</strong>
                        <p class="small help-block">Hide from product detail page</p>
                      </label>
                    </div>
                  </div>
                </div>

              </div>
            </box>

            <!-- Product Source -->
            <box id="source" title="Source">
              <div class="form-horizontal">
                <!-- Product Merchant -->
                <div class="form-group">
                  <label for="merchant" class="control-label col-md-2">
                    Merchant <span class="req" v-if="!isKlook">*</span>
                  </label>

                  <div class="col-md-8">
                    <v-select
                      name="merchant"
                      placeholder="Select product merchant"
                      v-model="form.merchant"
                      :options="list.merchants"
                      :class="{ disabled: vselect_disabled }">
                    </v-select>
                  </div>
                </div>

                <!-- Product Vendor -->
                <div class="form-group">
                  <label for="vendor" class="control-label col-md-2">
                    Source <span class="req">*</span>
                  </label>

                  <div class="col-md-8">
                    <v-select
                      name="vendor"
                      placeholder="Select product source"
                      v-model="form.vendor"
                      :clearable="false"
                      :options="list.vendors"
                      :class="{ disabled: vselect_disabled }">
                    </v-select>
                  </div>
                </div>

                <!-- Product Klook Code -->
                <div class="form-group" v-if="isKlook">
                  <label for="vendor" class="control-label col-md-2">
                    Klook Code
                  </label>

                  <div class="col-md-8">
                    <input type="text"
                      id="product_code"
                      class="form-control"
                      placeholder="Klook product code"
                      v-model="form.product_code"/>
                  </div>
                </div>
              </div>
            </box>

            <!-- Product Booking -->
            <box v-if="params.flaging === 'explore'" id="booking" title="Booking">
              <div class="form-horizontal">
                <!-- Toggle Options -->
                <div class="form-group">
                  <label for="criteria"
                    class="control-label col-md-2">
                    Booking Options
                  </label>

                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="form.has_criteria" @click="resetField('open date')">
                            <strong>Open date</strong>
                            <p class="small help-block">Limit ticket validity by date range. Booking Date will be overriden.</p>
                          </label>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="form.has_booking_duration" @click="resetField('booking duration')">
                            <strong>Booking duration</strong>
                            <p class="small help-block">Define minimum days tickets can be booked before travel date.</p>
                          </label>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="form.has_travel_duration" @click="resetField('travel duration')">
                            <strong>Travel duration</strong>
                            <p class="small help-block">Define ticket validity duration based on issued booking date.</p>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <hr>

                <!-- Booking type/criteria -->
                <div class="form-group" v-if="form.has_criteria">
                  <label for="criteria"
                    class="control-label col-md-2">
                    Booking Criteria <span class="req">*</span>
                  </label>

                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-5">
                        <div class="form-inline">
                          <div class="form-group">
                            <div class="input-group">
                              <div class="input-group-addon">From</div>
                              <datepicker
                                v-model="form.valid_from"
                                :disabled="configs.datepicker.disabled"
                                format="dd MMMM yyyy"
                                placeholder="Min. date"
                                input-class="form-control position-static"
                                name="min-booking-date">
                              </datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-5">
                        <div class="form-inline">
                          <div class="form-group">
                            <div class="input-group">
                              <div class="input-group-addon">To</div>
                              <datepicker
                                v-model="form.valid_to"
                                :disabled="generateDisabledDate('valid_to')"
                                format="dd MMMM yyyy"
                                placeholder="Max. date"
                                input-class="form-control position-static"
                                name="max-booking-date">
                              </datepicker>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Booking Duration - Minimum Days -->
                <div class="form-group" v-if="form.has_booking_duration">
                  <label for="minimum_days"
                    class="control-label col-md-2">
                    Booking Duration
                  </label>

                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-inline">
                          <div class="form-group">
                            <div class="input-group">
                              <input type="number"
                                class="form-control position-static"
                                id="booking_duration"
                                placeholder="Booking duration"
                                min="0"
                                max="31"
                                v-model="form.booking_duration">
                              <div class="input-group-addon">{{ form.booking_duration | pluralDays }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Travel Duration -->
                <div class="form-group" v-if="form.has_travel_duration">
                  <label for="minimum_days"
                    class="control-label col-md-2">
                    Travel Duration
                  </label>

                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-5">
                        <div class="form-inline">
                          <div class="form-group">
                            <div class="input-group">
                              <div class="input-group-addon">Amount</div>
                              <input type="number"
                                class="form-control"
                                id="travel_duration"
                                placeholder="Travel duration"
                                min="0"
                                v-model="form.travel_duration">
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <v-select
                          name="travel_duration_unit"
                          placeholder="Duration unit"
                          :options="list.travel_duration_unit"
                          v-model="form.travel_duration_unit"
                          :class="{ disabled: vselect_disabled }">
                        </v-select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Booking Date -->
                <div class="form-group">
                  <label for="booking-date"
                    class="control-label col-md-2">
                    Booking Date <span class="req">*</span>
                  </label>

                  <div class="col-md-10">
                    <transition-group name="slideDown">
                      <div class="row"
                        v-for="(item, index) in form.booking.bookingDate"
                        :key="index">
                        <div class="col-md-5">
                          <div class="form-inline">
                            <div class="form-group">
                              <div class="input-group">
                                <div class="input-group-addon">From</div>
                                <datepicker
                                  v-model="form.booking.bookingDate[index].from"
                                  :disabled="generateDisabledDate('bookingDate', index, null, 'from')"
                                  :open-date="openDateFromMinDate('bookingDate', index, null, 'from')"
                                  format="dd MMMM yyyy"
                                  placeholder="Min. booking date"
                                  input-class="form-control position-static"
                                  name="min-booking-date">
                                </datepicker>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5">
                          <div class="form-inline">
                            <div class="form-group">
                              <div class="input-group">
                                <div class="input-group-addon">To</div>
                                <datepicker
                                  v-model="form.booking.bookingDate[index].to"
                                  :disabled="generateDisabledDate('bookingDate', index, null, 'to')"
                                  :open-date="openDateFromMinDate('bookingDate', index, null, 'to')"
                                  format="dd MMMM yyyy"
                                  placeholder="Max. booking date"
                                  input-class="form-control position-static"
                                  name="max-booking-date">
                                </datepicker>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <button class="btn btn-info btn-xs"
                            @click.prevent="addItem('booking')">
                            <i class="fa fa-plus"></i>
                          </button>
                          <button class="btn btn-danger btn-xs"
                            v-if="index > 0"
                            @click.prevent="removeItem(item, 'booking', index)">
                            <i class="fa fa-minus"></i>
                          </button>
                        </div>
                      </div>
                    </transition-group>
                  </div>
                </div>

                <!-- Travel Date -->
                <div class="form-group" v-if="!isKlook">
                  <label for="travel-date"
                    class="control-label col-md-2">
                    Travel Date <span class="req">*</span>
                  </label>

                  <div class="col-md-10">
                    <transition-group name="slideDown">
                      <div class="row"
                        v-for="(item, index) in form.booking.travelDate"
                        :key="index">
                        <div class="col-md-5">
                          <div class="form-inline">
                            <div class="form-group">
                              <div class="input-group">
                                <div class="input-group-addon">From</div>
                                <datepicker
                                v-model="form.booking.travelDate[index].from"
                                :disabled="generateDisabledDate('travelDate', index, null, 'from')"
                                :open-date="openDateFromMinDate('travelDate', index, null, 'from')"
                                format="dd MMMM yyyy"
                                placeholder="Min. travel date"
                                input-class="form-control position-static"
                                name="min-travel-date">
                              </datepicker>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-5">
                          <div class="form-inline">
                            <div class="form-group">
                              <div class="input-group">
                                <div class="input-group-addon">To</div>
                                <datepicker
                                v-model="form.booking.travelDate[index].to"
                                :disabled="generateDisabledDate('travelDate', index, null, 'to')"
                                :open-date="openDateFromMinDate('travelDate', index, null, 'to')"
                                format="dd MMMM yyyy"
                                placeholder="Max. travel date"
                                input-class="form-control position-static"
                                name="max-travel-date">
                              </datepicker>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-2">
                          <button class="btn btn-info btn-xs"
                            @click.prevent="addItem('travel')">
                            <i class="fa fa-plus"></i>
                          </button>
                          <button class="btn btn-danger btn-xs"
                            v-if="index > 0"
                            @click.prevent="removeItem(item, 'travel', index)">
                            <i class="fa fa-minus"></i>
                          </button>
                        </div>
                      </div>
                    </transition-group>
                  </div>
                </div>

                <!-- Start Time -->
                <div class="form-group">
                  <label
                    for="start_time"
                    class="col-sm-2 control-label">
                    Start Time <span class="req">*</span>
                  </label>

                  <div class="col-sm-10 time-width">
                    <vue-timepicker
                      class="v-timepicker"
                      id="start_time"
                      hide-clear-button
                      format="HH:mm:ss"
                      v-model="form.booking.start_time">
                    </vue-timepicker>
                  </div>
                </div>

                <!-- End Time -->
                <div class="form-group">
                  <label
                    for="end_time"
                    class="col-sm-2 control-label">
                    End Time <span class="req">*</span>
                  </label>

                  <div class="col-sm-10 time-width">
                    <vue-timepicker
                      class="v-timepicker"
                      id="end_time"
                      hide-clear-button
                      format="HH:mm:ss"
                      v-model="form.booking.end_time">
                    </vue-timepicker>
                  </div>
                </div>
              </div>
            </box>

            <!-- Product Tour Booking -->
            <box v-if="params.flaging === 'tour'" id="booking" title="Booking">
              <div class="form-horizontal">

                <!-- Boking Option -->
                <div class="form-group">
                  <label for="booking-options"
                    class="control-label col-md-2">
                    Booking Option
                  </label>
                  <div class="col-sm-10">
                    <label class="radio-inline">
                      <input
                        id="booking-options"
                        type="radio"
                        name="booking-options"
                        value="0"
                        v-model="form.booking_tour.bookingOption">
                        Entrance
                    </label>
                    <label class="radio-inline">
                      <input
                        id="booking-options"
                        type="radio"
                        name="booking-options"
                        value="1"
                        v-model="form.booking_tour.bookingOption">
                        Open Trip
                    </label>
                  </div>
                </div>

                <!-- Booking Duration - Minimum Days -->
                <div class="form-group">
                  <label for="minimum_days"
                    class="control-label col-md-2">
                    Booking Duration
                  </label>

                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-inline">
                          <div class="form-group">
                            <div class="input-group">
                              <input type="number"
                                class="form-control position-static"
                                id="booking_duration"
                                placeholder="Booking duration"
                                min="0"
                                max="31"
                                v-model="form.booking_tour.bookingDuration">
                              <div class="input-group-addon">{{ form.booking_duration | pluralDays }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Booking Date -->
                <div class="form-group">
                  <label for="booking-date"
                    class="control-label col-md-2">
                    Booking Date <span class="req">*</span>
                  </label>

                  <div class="col-md-10">
                    <transition-group name="slideDown">
                      <div class="row"
                        v-for="(item, index) in form.booking_tour.bookingDate"
                        :key="index">
                        <div class="col-md-5">
                          <div class="form-inline">
                            <div class="form-group">
                              <div class="input-group">
                                <div class="input-group-addon">From</div>
                                <datepicker
                                  v-model="form.booking_tour.bookingDate[index].from"
                                  :disabled="generateDisabledDate('bookingDate', index, null, 'from')"
                                  :open-date="openDateFromMinDate('bookingDate', index, null, 'from')"
                                  format="dd MMMM yyyy"
                                  placeholder="Min. booking date"
                                  input-class="form-control position-static"
                                  name="min-booking-date">
                                </datepicker>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5">
                          <div class="form-inline">
                            <div class="form-group">
                              <div class="input-group">
                                <div class="input-group-addon">To</div>
                                <datepicker
                                  v-model="form.booking_tour.bookingDate[index].to"
                                  :disabled="generateDisabledDate('bookingDate', index, null, 'to')"
                                  :open-date="openDateFromMinDate('bookingDate', index, null, 'to')"
                                  format="dd MMMM yyyy"
                                  placeholder="Max. booking date"
                                  input-class="form-control position-static"
                                  name="max-booking-date">
                                </datepicker>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <button class="btn btn-info btn-xs"
                            @click.prevent="addItem('booking')">
                            <i class="fa fa-plus"></i>
                          </button>
                          <button class="btn btn-danger btn-xs"
                            v-if="index > 0"
                            @click.prevent="removeItem(item, 'booking', index)">
                            <i class="fa fa-minus"></i>
                          </button>
                        </div>
                      </div>
                    </transition-group>
                  </div>
                </div>

                <!-- Travel Date -->
                <div class="form-group">
                  <label for="travel-date"
                    class="control-label col-md-2">
                    Travel Date <span class="req">*</span>
                  </label>

                  <div class="col-md-10">
                    <transition-group name="slideDown">
                      <div class="row"
                        v-for="(item, index) in form.booking_tour.travelDate"
                        :key="index">
                        <div class="col-md-5">
                          <div class="form-inline">
                            <div class="form-group">
                              <div class="input-group">
                                <div class="input-group-addon">From</div>
                                <datepicker
                                v-model="form.booking_tour.travelDate[index].from"
                                :disabled="generateDisabledDate('travelDate', index, null, 'from')"
                                :open-date="openDateFromMinDate('travelDate', index, null, 'from')"
                                format="dd MMMM yyyy"
                                placeholder="Min. travel date"
                                input-class="form-control position-static"
                                name="min-travel-date">
                              </datepicker>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-5">
                          <div class="form-inline">
                            <div class="form-group">
                              <div class="input-group">
                                <div class="input-group-addon">To</div>
                                <datepicker
                                v-model="form.booking_tour.travelDate[index].to"
                                :disabled="generateDisabledDate('travelDate', index, null, 'to')"
                                :open-date="openDateFromMinDate('travelDate', index, null, 'to')"
                                format="dd MMMM yyyy"
                                placeholder="Max. travel date"
                                input-class="form-control position-static"
                                name="max-travel-date">
                              </datepicker>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-2">
                          <button class="btn btn-info btn-xs"
                            @click.prevent="addItem('travel')">
                            <i class="fa fa-plus"></i>
                          </button>
                          <button class="btn btn-danger btn-xs"
                            v-if="index > 0"
                            @click.prevent="removeItem(item, 'travel', index)">
                            <i class="fa fa-minus"></i>
                          </button>
                        </div>
                      </div>
                    </transition-group>
                  </div>
                </div>


                <!-- Start Time -->
                <div class="form-group">
                  <label
                    for="start_time"
                    class="col-sm-2 control-label">
                    Start Time <span class="req">*</span>
                  </label>

                  <div class="col-sm-10 time-width">
                    <vue-timepicker
                      class="v-timepicker"
                      id="start_time"
                      hide-clear-button
                      format="HH:mm:ss"
                      v-model="form.booking_tour.start_time">
                    </vue-timepicker>
                  </div>
                </div>

                <!-- End Time -->
                <div class="form-group">
                  <label
                    for="end_time"
                    class="col-sm-2 control-label">
                    End Time <span class="req">*</span>
                  </label>

                  <div class="col-sm-10 time-width">
                    <vue-timepicker
                      class="v-timepicker"
                      id="end_time"
                      hide-clear-button
                      format="HH:mm:ss"
                      v-model="form.booking_tour.end_time">
                    </vue-timepicker>
                  </div>
                </div>
              </div>
            </box>

            <!-- Product Packages -->
            <box id="packages" title="Packages">
              <div class="package-list">
                <transition-group name="slideDown">
                  <div class="panel panel-primary panel-package"
                    v-for="(item, index) in form.booking.packages"
                    :key="index">
                    <div class="panel-heading">
                      <h3 class="panel-title">
                        Package #{{ index + 1 }} {{ item.name }}
                        <span class="label label-danger pull-right"
                          @click.prevent="removeItem(item, 'packages')"
                          :class="{ disabled: vselect_disabled }"
                          v-if="index > 0">
                            Remove
                        </span>
                      </h3>
                    </div>

                    <div class="panel-body">
                      <div class="form-horizontal">
                        <!-- Package Title -->
                        <div class="form-group">
                          <label for="item_type_name" class="control-label col-md-2">
                            Title <span class="req">*</span>
                          </label>

                          <div class="col-md-8">
                            <tabs>
                              <tab name="Indonesia" :selected="true">
                                <input type="text"
                                  class="form-control"
                                  id="item_type_name"
                                  placeholder="Package title Indonesia"
                                  v-model="form.booking.packages[index].name">
                              </tab>

                              <tab name="English">
                                <input type="text"
                                  class="form-control"
                                  id="item_type_name_en"
                                  placeholder="Package title english"
                                  v-model="form.booking.packages[index].name_en">
                              </tab>
                            </tabs>
                          </div>
                        </div>

                        <!-- Package Description -->
                        <div class="form-group">
                          <label for="item_type" class="control-label col-md-2">
                            Description <span class="req">*</span>
                          </label>

                          <div class="col-md-8">
                            <tabs>
                              <tab name="Indonesia" :selected="true">
                                <input type="text"
                                  class="form-control"
                                  id="description"
                                  placeholder="Package description Indonesia"
                                  v-model="form.booking.packages[index].description">
                              </tab>

                              <tab name="English">
                                <input type="text"
                                  class="form-control"
                                  id="description_en"
                                  placeholder="Package description English"
                                  v-model="form.booking.packages[index].description_en">
                              </tab>
                            </tabs>
                          </div>
                        </div>

                        <!-- Package Klook SKU ID -->
                        <div class="form-group" v-if="isKlook">
                          <label for="sku_id" class="control-label col-md-2">
                            SKU ID <span class="req">*</span>
                          </label>

                          <div class="col-md-8">
                            <input type="text"
                              class="form-control"
                              id="sku_id"
                              placeholder="Klook SKU ID"
                              v-model="form.booking.packages[index].sku_id">

                            <p class="help-block" v-if="form.booking.packages[index].sku_title">
                              <i class="fa fa-fw fa-check-circle-o text-success"></i>
                              {{ form.booking.packages[index].sku_title }}
                            </p>
                          </div>

                          <div class="col-md-2">
                            <button class="btn btn-block btn-info"
                              @click.prevent="fetchKlookPrice(form.booking.packages[index].sku_id, index)">
                              <span v-if="!klookLoading">Fetch</span>
                              <i class="fa fa-fw fa-spinner fa-spin" v-else></i>
                            </button>
                          </div>
                        </div>

                        <!-- Package Klook Travel Date -->
                        <div class="form-group" v-if="isKlook">
                          <label for="travel-date"
                            class="control-label col-md-2">
                            Travel Date <span class="req">*</span>
                          </label>

                          <div class="col-md-10">
                            <transition-group name="slideDown">
                              <div class="row"
                                v-for="(itemTravel, indexTravel) in form.booking.packages[index].travel_date"
                                :key="`travel-date-${indexTravel}`">
                                <div class="col-md-5">
                                  <div class="form-inline">
                                    <div class="form-group">
                                      <div class="input-group">
                                        <div class="input-group-addon">From</div>
                                        <datepicker
                                          v-model="form.booking.packages[index].travel_date[indexTravel].from"
                                          :disabled="generateDisabledDate('klook', indexTravel, index, 'from')"
                                          format="dd MMMM yyyy"
                                          placeholder="Min. travel date"
                                          input-class="form-control position-static"
                                          name="min-travel-date">
                                        </datepicker>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-5">
                                  <div class="form-inline">
                                    <div class="form-group">
                                      <div class="input-group">
                                        <div class="input-group-addon">To</div>
                                        <datepicker
                                          v-model="form.booking.packages[index].travel_date[indexTravel].to"
                                          :disabled="generateDisabledDate('klook', indexTravel, index, 'to')"
                                          format="dd MMMM yyyy"
                                          placeholder="Max. travel date"
                                          input-class="form-control position-static"
                                          name="max-travel-date">
                                        </datepicker>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-md-2">
                                  <button class="btn btn-info btn-xs"
                                    @click.prevent="addItem('klook-travel', index)">
                                    <i class="fa fa-plus"></i>
                                  </button>
                                  <button class="btn btn-danger btn-xs"
                                    v-if="indexTravel > 0"
                                    @click.prevent="removeItem(item, 'klook-travel', indexTravel)">
                                    <i class="fa fa-minus"></i>
                                  </button>
                                </div>
                              </div>
                            </transition-group>
                          </div>
                        </div>

                        <!-- Package Multiplier -->
                        <div class="form-group">
                          <label for="multiplier" class="control-label col-md-2">
                            Multiplier <span class="req">*</span>
                          </label>

                          <div class="col-md-8">
                            <input type="text"
                              class="form-control"
                              id="multiplier"
                              placeholder="Quantity multiplier"
                              v-model="form.booking.packages[index].multiply">
                          </div>
                        </div>

                        <!-- Package Type -->
                        <div class="form-group">
                          <label :for="`ageMax-${index}`" class="control-label col-md-2">
                            Type <span class="req">*</span>
                          </label>

                          <div class="col-md-8">
                            <v-select
                              name="type"
                              placeholder="Select age type"
                              v-model="form.booking.packages[index].type"
                              :options="list.type"
                              :class="{ disabled: vselect_disabled }">
                            </v-select>
                          </div>
                        </div>

                        <!-- Package Min/Max Person -->
                        <div class="form-group">
                          <label for="minimum_person" class="control-label col-md-2">
                            Person <span class="req">*</span>
                          </label>

                          <div class="col-md-8">
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-inline">
                                  <div class="form-group">
                                    <div class="input-group">
                                      <div class="input-group-addon">Min</div>
                                      <input type="number"
                                        class="form-control form-shrink position-static"
                                        id="min_person"
                                        placeholder="Minimum person(s)"
                                        v-model="form.booking.packages[index].min_person" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-inline">
                                  <div class="form-group">
                                    <div class="input-group">
                                      <div class="input-group-addon">Max</div>
                                      <input type="number"
                                        class="form-control position-static"
                                        id="max_person"
                                        placeholder="Maximum person(s)"
                                        v-model="form.booking.packages[index].max_person" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Package Ticket Inventory -->
                        <div class="form-group" v-if="!isKlook">
                          <label for="ticket" class="control-label col-md-2">
                            Inventory <span class="req">*</span>
                          </label>

                          <div class="col-md-8">
                            <v-select
                              name="ticket"
                              placeholder="Select ticket inventory"
                              v-model="form.booking.packages[index].ticket"
                              :options="list.tickets"
                              :class="{ disabled: vselect_disabled }">
                            </v-select>
                          </div>
                        </div>

                        <!-- Package Prices -->
                        <div class="form-group">
                          <label for="prices" class="control-label col-md-2">
                            Prices <span class="req">*</span>
                          </label>

                          <div class="col-md-8">
                            <transition-group name="slideDown">
                              <div class="panel panel-info"
                                v-for="(price, priceIndex) in item.prices"
                                :key="priceIndex">
                                <div class="panel-heading">
                                  <h3 class="panel-title">
                                    Price #{{ priceIndex + 1 }}

                                    <span class="label label-success ml-2"
                                      v-if="publishRate(index, priceIndex)">
                                      {{publishRate(index, priceIndex)}}
                                    </span>

                                    <span class="label label-danger ml-2"
                                      v-if="priceIndex > 0"
                                      @click.prevent="removeItem(item, 'price', priceIndex)"
                                      :class="{ disabled: vselect_disabled }">
                                        Remove
                                    </span>

                                    <span class="label label-info pull-right"
                                      @click.prevent="fetchKlookPrice(form.booking.packages[index].sku_id, index)">
                                      <span v-if="!klookLoading">Update Price</span>
                                      <template v-else>
                                        <i class="fa fa-fw fa-spinner fa-spin"></i> loading..
                                      </template>
                                    </span>
                                  </h3>
                                </div>

                                <div class="panel-body">
                                  <div class="row">
                                    <div class="col-sm-12" :class="{ 'col-md-6': isKlook, }">
                                      <div class="form-group">
                                        <label for="item_min">Min Qty</label>

                                        <input type="number"
                                          class="form-control form-shrink"
                                          placeholder="E.g.: 5"
                                          id="item_min"
                                          min="0"
                                          v-model="form.booking.packages[index].prices[priceIndex].min_qty">
                                      </div>

                                      <div class="form-group">
                                        <label for="base_cost">
                                          Nett <span class="req">*</span>
                                        </label>

                                        <input type="number"
                                          class="form-control form-shrink"
                                          id="base_cost"
                                          placeholder="0.00"
                                          min="0"
                                          :readonly="isKlook"
                                          v-model="form.booking.packages[index].prices[priceIndex].base_cost">
                                      </div>

                                      <div class="form-group">
                                        <label for="block_cost">
                                          Commission <span class="req">*</span>
                                        </label>

                                        <div class="input-group select-group group-width">
                                            <select
                                              class="form-control input-group-addon select-width"
                                              id="block_cost_type"
                                              v-model="form.booking.packages[index].prices[priceIndex].block_cost.type">
                                                <option :value="0">Percentage</option>
                                                <option :value="1">Amount</option>
                                            </select>
                                            <input
                                              type="number"
                                              class="form-control input-width"
                                              id="block_cost"
                                              placeholder="0.00"
                                              min="0"
                                              v-model="form.booking.packages[index].prices[priceIndex].block_cost.value"/>
                                        </div>
                                      </div>

                                      <div class="form-group">
                                        <label for="item_type_name">
                                          Price per
                                        </label>

                                        <tabs>
                                          <tab name="Indonesia" :selected="true">
                                            <input type="text"
                                              class="form-control"
                                              id="item_type_name"
                                              placeholder="Unit teks. Contoh: IDR 344.000/kamar atau IDR 344.000/paket"
                                              v-model="form.booking.packages[index].prices[priceIndex].price_per_type">
                                          </tab>

                                          <tab name="English">
                                            <input type="text"
                                              class="form-control"
                                              id="item_type_name_en"
                                              placeholder="Unit text. Example: IDR 344.000/room atau IDR 344.000/package"
                                              v-model="form.booking.packages[index].prices[priceIndex].price_per_type_en">
                                          </tab>
                                        </tabs>
                                      </div>

                                      <div class="form-group">
                                        <label for="gimmick_price">Display Price</label>

                                        <input type="number"
                                          class="form-control form-shrink"
                                          placeholder="E.g.: 2000000"
                                          id="gimmick_price"
                                          min="0"
                                          v-model="form.booking.packages[index].prices[priceIndex].gimmick_price">
                                      </div>
                                    </div>

                                    <div class="col-sm-12 col-md-6" v-if="isKlook">
                                      <div class="form-group">
                                        <label for="currency">
                                          Currency <span class="req">*</span>
                                        </label>

                                        <input type="text"
                                          class="form-control"
                                          id="currency"
                                          placeholder="IDR, SGD, USD, GBP"
                                          min="0"
                                          v-model="form.booking.packages[index].prices[priceIndex].currency">
                                      </div>

                                      <div class="form-group">
                                        <label for="source_price">
                                          Source Price <span class="req">*</span>
                                        </label>

                                        <input type="number"
                                          class="form-control"
                                          id="source_price"
                                          placeholder="0.00"
                                          min="0"
                                          readonly="readonly"
                                          v-model="form.booking.packages[index].prices[priceIndex].source_price">
                                      </div>

                                      <div class="form-group">
                                        <label for="exchange_rate">
                                          Exchange Rate <span class="req">*</span>
                                        </label>

                                        <input type="number"
                                          class="form-control"
                                          id="exchange_rate"
                                          placeholder="0.00"
                                          min="0"
                                          readonly="readonly"
                                          v-model="form.booking.packages[index].prices[priceIndex].exchange_rate">
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="panel-footer" v-show="form.booking.packages[index].prices[priceIndex].hasOwnProperty('start_from')">
                                  <label for="start_from">
                                    <input
                                      id="start_from"
                                      class="form-check"
                                      type="checkbox"
                                      v-model="form.booking.packages[index].prices[priceIndex].start_from"
                                      v-on:change="setPriceStartFrom(index, priceIndex)"> Start from
                                  </label>
                                </div>
                              </div>
                            </transition-group>

                            <button class="btn btn-block btn-info btn-sm"
                              @click.prevent="addItem('price', index)">
                              Add Price
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </div>

              <button class="btn btn-block btn-info btn-sm"
                @click.prevent="addItem('package')">
                Add more package
              </button>
            </box>

            <!-- Sequence and Badge -->
            <box id="sequence" title="Sequence and Badge">
              <div class="form-horizontal">

                <div class="form-group">
                  <label for="sequence" class="control-label col-md-2">
                    Sequence <span class="req">*</span>
                  </label>

                  <div class="col-md-8">
                    <input type="text"
                      class="form-control"
                      placeholder="E.g.: 2"
                      id="sequence"
                      v-model="form.sequence">
                  </div>
                </div>

                <div class="form-group" v-if="!isCreate">
                  <label for="badge"
                    class="control-label col-md-2">
                    Badges
                  </label>

                  <div class="col-md-8">
                    <v-select multiple
                      name="badges"
                      placeholder="No Active Badges"
                      v-model="form.badges"
                      :clearable="false"
                      disabled>
                    </v-select>
                    <span>
                      The active Badges depend on the badges setup. Only eligible Badges will appear in this section
                    </span>
                  </div>
                </div>
              </div>
            </box>

            <!-- Product Contents -->
            <box id="contents" title="Content Tabs">
              <div class="panel panel-info"
                v-for="(tab, index) in form.tabs" :key="index">
                <div class="panel-heading">
                  <h3 class="panel-title">
                    Tab #{{ index + 1 }}: {{ tab.title }} <span v-if="tab.title_en">/ {{ tab.title_en }}</span>
                  </h3>
                </div>

                <div class="panel-body">
                  <tabs>
                    <tab name="Indonesia" :selected="true">
                      <input type="text"
                        class="form-control"
                        :id="`tab-name-${index}`"
                        :name="`tab-name-${index}`"
                        placeholder="Tab Title Indonesia"
                        v-model="form.tabs[index].title"
                        disabled />

                      <ckeditor
                        ref="richTextEditor"
                        placeholder="Tab content Indonesia"
                        :config="configs.ckeditor"
                        :id="`tab-description-${index}`"
                        :name="`tab-description-${index}`"
                        v-model="form.tabs[index].description">
                      </ckeditor>
                    </tab>

                    <tab name="English">
                      <input type="text"
                        class="form-control"
                        :id="`tab-name-en-${index}`"
                        :name="`tab-name-en-${index}`"
                        placeholder="Tab Title English"
                        v-model="form.tabs[index].title_en"
                        disabled />

                      <ckeditor
                        ref="richTextEditor"
                        placeholder="Tab content English"
                        :config="configs.ckeditor"
                        :id="`tab-description-en-${index}`"
                        :name="`tab-description-en-${index}`"
                        v-model="form.tabs[index].description_en">
                      </ckeditor>
                    </tab>
                  </tabs>
                </div>
              </div>
            </box>

            <!-- Voucher Contents -->
            <box id="voucher" title="Content on E-Voucher">
              <div class="panel panel-info"
                v-for="(vouchers, index) in form.vouchers" :key="index">
                <div class="panel-heading">
                  <h3 class="panel-title">
                    Group #{{ index + 1 }}: {{ vouchers.title }} <span v-if="vouchers.title_en">/ {{ vouchers.title_en }}</span>
                  </h3>
                </div>

                <div class="panel-body">
                  <tabs>
                    <tab name="Indonesia" :selected="true">
                      <input type="text"
                        class="form-control"
                        :id="`voucher-name-${index}`"
                        :name="`voucher-name-${index}`"
                        placeholder="Tab Title Indonesia"
                        v-model="form.vouchers[index].title"
                        disabled />

                      <ckeditor
                        ref="richTextEditor"
                        placeholder="Tab content Indonesia"
                        :config="configs.ckeditor"
                        :id="`voucher-description-${index}`"
                        :name="`voucher-description-${index}`"
                        v-model="form.vouchers[index].description">
                      </ckeditor>
                    </tab>

                    <tab name="English">
                      <input type="text"
                        class="form-control"
                        :id="`voucher-name-en-${index}`"
                        :name="`voucher-name-en-${index}`"
                        placeholder="Tab Title English"
                        v-model="form.vouchers[index].title_en"
                        disabled />

                      <ckeditor
                        ref="richTextEditor"
                        placeholder="Tab content English"
                        :config="configs.ckeditor"
                        :id="`voucher-description-en-${index}`"
                        :name="`voucher-description-en-${index}`"
                        v-model="form.vouchers[index].description_en">
                      </ckeditor>
                    </tab>
                  </tabs>
                </div>
              </div>
            </box>
          </div>

          <!-- Right Content -->
          <div class="col-12 col-md-3 col-lg-3">
            <affix class="sidebar-menu"
              relative-element-selector="#main-content"
              style="width: 240px"
              :offset="{ top: 20, bottom: 20 }">
              <!-- Product Publish -->
              <box id="publish" title="Publish" :border="true" :action="false">
                <div class="form-group">
                  <label for="published">
                    <input
                      class="form-check"
                      id="published"
                      name="published"
                      type="checkbox"
                      v-model="form.is_publish"> Published
                  </label>
                </div>

                <div v-if="isCreate">
                  <button type="submit" class="btn btn-info btn-block" :disabled="isSubmitting">
                    <span v-if="isSubmitting"><i class="fa fa-cog fa-spin fa-fw"></i> Saving</span>
                    <span v-else>Create</span>
                  </button>
                </div>

                <div v-else>
                  <div v-if="status_product === 'Need Approval'">
                    <button
                      type="button"
                      class="btn approved btn-block color-white"
                      :disabled="isSubmitting"
                      @click.prevent="submit('approved')">
                      <strong v-if="isSubmitting"><i class="fa fa-cog fa-spin fa-fw color-red"></i> Saving</strong>
                      <strong v-else>Approved</strong>
                    </button>
                    <button
                      type="button"
                      class="btn need-revision btn-block color-white"
                      :disabled="isSubmitting"
                      @click.prevent="submit('revision')">
                      <strong v-if="isSubmitting"><i class="fa fa-cog fa-spin fa-fw"></i> Saving</strong>
                      <strong v-else>Need Revision</strong>
                    </button>
                  </div>

                  <div v-else-if="status_product === 'Need Revision'">
                    <button type="submit" class="btn btn-info btn-block" disabled>
                      <strong >Update</strong>
                    </button>
                  </div>

                  <div v-else>
                    <button type="submit" class="btn btn-info btn-block" :disabled="isSubmitting">
                      <strong v-if="isSubmitting"><i class="fa fa-cog fa-spin fa-fw"></i> Saving</strong>
                      <strong v-else>Update</strong>
                    </button>
                  </div>
                </div>

                <a class="btn btn-link" @click.prevent="cancel">Cancel</a>

                <a :href="generatePreview(form.slug, form.id)" style="float: right;" class="btn btn-link" target="_blank" v-if="!isCreate">Preview</a>
              </box>

              <!-- Product Cover -->
              <box id="cover" title="Cover Thumbnail Web">
                <img class="img-thumbnail img-responsive" alt="Product Image Web"
                  v-if="form.image.url"
                  :src="getSize(form.image.url, 'thumb')">

                <button class="btn btn-sm btn-block btn-info"
                  @click.prevent="showModal('featured')">
                  Select Image
                </button>
              </box>

              <!-- Product Cover -->
              <box id="cover" title="Cover Thumbnail Apps">
                <img class="img-thumbnail img-responsive" alt="Product Image Apps"
                  v-if="form.image_apps.url"
                  :src="getSize(form.image_apps.url, 'thumb')">

                <button class="btn btn-sm btn-block btn-info"
                  @click.prevent="showModal('featured_apps')">
                  Select Image
                </button>
              </box>

              <!-- Product Gallery -->
              <box id="gallery" title="Media">
                <div v-if="form.gallery" class="gallery-grid-container">
                  <div v-for="(image, index) in form.gallery" :key="index" >
                    <div v-if="isVideo(image.url)" style="position: relative;">
                      <img
                        src="../../../assets/img/ic-play.svg"
                        style="position:absolute; z-index: 2; top:35%; left:40%"
                        alt="icon play"
                      >
                      <video>
                        <source  :src="image.url" type="video/mp4" >
                      </video>
                    </div>

                    <img v-else :src="getSize(image.url, 'thumb')" class="img"/>
                  </div>
                </div>

                <button class="btn btn-sm btn-block btn-info"
                  @click.prevent="showModal('gallery')">
                  Select Media
                </button>
              </box>

              <box id="cover" title="TICKET IMAGE">
                <img class="img-thumbnail img-responsive" alt="Ticket Image"
                  v-if="form.ticket_image.url"
                  :src="getSize(form.ticket_image.url, 'thumb')">

                <button class="btn btn-sm btn-block btn-info"
                  @click.prevent="showModal('ticket_image')">
                  Select Image
                </button>
              </box>

              <!-- Product Error -->
              <div v-if="error" class="alert alert-danger">
                <a class="close" @click="error = false">&times;</a>
                {{ error }}
              </div>
            </affix>

            <i class="fa fa-3x fa-arrow-circle-up goto-arrow" v-scroll-to="'#top'"></i>
          </div>
        </div>
      </form>

      <ModalCategories
        :show="show.categories"
        :option-form.sync="optionForm"
        @add="addOption('categories')"
        @setImage="setImage" />

      <ModalDestinations
        :show="show.destinations"
        :option-form.sync="optionForm"
        :list.sync="list"
        @add="addOption('destination')"
        @setImage="setImage" />

      <transition name="slideDown">
        <modal title="Choose Media for Gallery"
          v-if="show.gallery">
          <FileGallery
            type="gallery"
            :allow-video="true"
            :is-multiple="true"
            :selected="form.gallery"
            @update-images="setImage" />
        </modal>
      </transition>

      <transition name="slideDown">
        <modal title="Select Featured Image"
          v-if="show.featured">
          <FileGallery
            type="featured"
            :is-multiple="false"
            :selected="form.image"
            @update-images="setImage" />
        </modal>
      </transition>

      <transition name="slideDown">
        <modal title="Select Featured Apps Image"
          v-if="show.featured_apps">
          <FileGallery
            type="featured_apps"
            :is-multiple="false"
            :selected="form.image_apps"
            @update-images="setImage" />
        </modal>
      </transition>

      <transition name="slideDown">
        <modal title="Select Ticket Image"
          v-if="show.ticket_image">
          <FileGallery
            type="ticket_image"
            :is-multiple="false"
            :selected="form.ticket_image"
            @update-images="setImage" />
        </modal>
      </transition>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import numeral from 'numeral';
import flatten from 'lodash/flatten';
import { Circle } from 'vue-loading-spinner';
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from 'vue2-timepicker';
import { Treeselect, LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect';
import { WEB_URL } from '@/config'; // eslint-disable-line no-unused-vars
import bus from '@/utils/bus';
import Common from '@/mixins/Common';
import Modal from '@/components/modules/common/Modal';
import Ckeditor from '@/components/modules/common/Ckeditor';
import FileGallery from '@/components/modules/common/FileGallery';
import ContentHeader from '@/components/modules/common/ContentHeader';
import Box from '@/components/modules/common/Box';
import Quickjump from './partials/Quickjump';
import Tabs from './partials/LanguageTabs';
import Tab from './partials/LanguageTab';
import ModalTags from './partials/ModalTags';
import ModalMoods from './partials/ModalMoods';
import ModalCategories from './partials/ModalCategories';
import ModalDestinations from './partials/ModalDestinations';


export default {
  name: 'ProductForm',

  mixins: [Common],

  data() {
    return {
      title: 'Create Product',
      videoExtensions: ['.mp4', '.webm'],
      breadcrumbs: [
        {
          name: 'Products',
          link: 'product-index',
        },
      ],

      params: {
        flaging: null,
      },

      status_product: null,
      vselect_disabled: false,
      isLoading: true,
      isSubmitting: false,
      isHidden: false,
      error: null,
      klookLoading: false,

      form: {
        id: null,
        name: null,
        name_en: null,
        slug: null,

        vendor: null,
        merchant: null,
        product_code: null,

        categories: null,
        destinations: null,
        type: {
          label: 'Domestic',
          value: 'domestic',
        },

        condition: {
          label: 'No need specific condition',
          value: 0,
        },
        with_adult_is_must: 0,
        print_voucher: 0,

        has_criteria: true,
        open_date: 1,
        fixed_date: 0,
        valid_from: null,
        valid_to: null,

        has_booking_duration: false,
        booking_duration: 0,
        booking_duration_unit: 'days',

        has_travel_duration: false,
        travel_duration: 0,
        travel_duration_unit: {
          label: 'day',
          value: 'day',
        },

        tags: null,

        gallery: null,
        image: {
          id: null,
          url: null,
        },
        image_apps: {
          id: null,
          url: null,
        },

        booking: {
          buff_period: null,
          is_open_trip: false,
          start_time: {
            HH: '00',
            mm: '00',
            ss: '00',
          },
          end_time: {
            HH: '23',
            mm: '59',
            ss: '59',
          },
          bookingDate: [
            {
              from: null,
              to: null,
            },
          ],
          travelDate: [
            {
              from: null,
              to: null,
            },
          ],
          packages: [
            {
              id: null,
              sku_id: null,
              sku_title: null,
              name_en: null,
              name: null,
              multiply: 1,
              description: null,
              description_en: null,
              age_max: 0,
              ticket: null,
              min_person: null,
              max_person: null,
              type: null,
              travel_date: [
                {
                  from: null,
                  to: null,
                },
              ],
              prices: [
                {
                  id: null,
                  base_cost: null,
                  block_cost: {
                    type: 0,
                    value: null,
                  },
                  min_qty: 1,
                  start_from: 1,
                  source_price: null,
                  exchange_rate: null,
                  currency: null,
                  price_per_type: 'pax',
                  price_per_type_en: 'pax',
                  gimmick_price: null,
                },
              ],
            },
          ],
        },

        booking_tour: {
          bookingOption: '0',
          bookingDuration: null,
          bookingDate: [
            {
              from: null,
              to: null,
            },
          ],
          travelDate: [
            {
              from: null,
              to: null,
            },
          ],
          start_time: {
            HH: '00',
            mm: '00',
            ss: '00',
          },
          end_time: {
            HH: '23',
            mm: '59',
            ss: '59',
          },
        },

        sequence: null,
        badges: null,

        tabs: [
          {
            title: 'Informasi',
            title_en: 'Information',
            description: null,
            description_en: null,
          },
          {
            title: 'Harga Termasuk',
            title_en: 'Price Includes',
            description: null,
            description_en: null,
          },
          {
            title: 'Harga Tidak Termasuk',
            title_en: 'Price Excludes',
            description: null,
            description_en: null,
          },
          {
            title: 'Syarat dan Ketentuan',
            title_en: 'Term and Conditions',
            description: null,
            description_en: null,
          },
        ],

        vouchers: [],
        visibility: true,
        is_publish: true,
        hide_breadcrumbs: false,
        hide_searchbar: false,
        hide_recommendation: false,
        ticket_image: {
          id: null,
          url: null,
        },
      },

      exchange: {
        rate: null,
        currency: null,
      },

      optionForm: {
        categories: {
          name: null,
          name_en: null,
          slug: null,
          image: {
            id: null,
            url: null,
          },
        },

        destinations: {
          name: null,
          slug: null,
          parent: null,
          image: {
            id: null,
            url: null,
          },
        },
      },

      list: {
        flatDestinations: [],
        destinations: [],
        categories: [],
        tags: [],
        vendors: [],
        merchants: [],
        tickets: [],
        region: [
          {
            label: 'Domestic',
            value: 'domestic',
          },
          {
            label: 'International',
            value: 'international',
          },
        ],
        type: [
          {
            label: 'Anak-anak',
            value: 'children',
          },
          {
            label: 'Dewasa',
            value: 'adult',
          },
          {
            label: 'Senior',
            value: 'senior',
          },
        ],
        condition: [
          {
            label: 'No need specific condition',
            value: 0,
          },
          {
            label: 'With adult is a must',
            value: 1,
          },
        ],

        travel_duration_unit: [
          {
            label: 'day',
            value: 'day',
          },
          {
            label: 'week',
            value: 'week',
          },
          {
            label: 'month',
            value: 'month',
          },
        ],
      },

      destinationListUpdated: false,
      hasStartFrom: 0,

      show: {
        gallery: false,
        featured: false,
        featured_apps: false,
        categories: false,
        destinations: false,
        tags: false,
        ticket_image: false,
      },

      configs: {
        datepicker: {
          disabled: {
            to: moment().subtract(1, 'd').toDate(),
          },
        },

        ckeditor: {
          toolbar: [
            {
              name: 'basicstyles',
              items: [
                'Styles',
                'Format',
                '-',
                'Bold',
                'Italic',
                'Strike',
                '-',
                'NumberedList',
                'BulletedList',
                '-',
                'Source',
              ],
            },
            {
              name: 'links',
              items: [
                'Link',
                'Unlink',
                'Anchor',
              ],
            },
          ],
          height: 200,
          extraPlugins: 'uploadimage',
          uploadUrl: '/static/temp/',
        },
      },

      passRoute: {
        name: 'product-index-page',
        params: { page: 1 },
        query: null,
      },
    };
  },

  props: {
    isCreate: {
      type: Boolean,
      required: false,
    },
  },

  computed: {
    isKlook() {
      return this.form.vendor && (this.form.vendor.label === 'Klook');
    },
  },

  components: {
    Box,
    Ckeditor,
    ContentHeader,
    Datepicker,
    FileGallery,
    Modal,
    ModalCategories,
    ModalDestinations,
    ModalMoods,
    ModalTags,
    ProgressLoader: Circle,
    Quickjump,
    Tab,
    Tabs,
    Treeselect,
    VueTimepicker,
  },

  filters: {
    pluralDays(number) {
      const num = parseInt(number, 10);
      if (!num) return 'Day';
      if (num > 1) return 'Days';
      return 'Day';
    },
  },
  watch: {
    'form.type': function () {
       this.fetchDestination();
    },
  },
  methods: {
    fetchItem(type) {
      return new Promise((resolve) => {
        const itemParams = {
          perpage: 5000,
          type_product: null,
        };
        if (type === 'tickets') {
          itemParams.type_product = this.params.flaging;
        }

        let enpoint = type;
        if (type === 'tickets') {
          enpoint = 'tickets-only';
        }

        this.axios.get(`/${enpoint}`, { params: itemParams })
          .then((response) => {
            let { data } = response.data;
            if (!data) data = [];
            const results = data.map(item => ({ label: item.name, value: item.id }));
            this.list[type] = results;
            resolve(data);
          })
          .catch((error) => {
            console.log(`Fetch ${type} error`, error);

            if (error.response) {
              this.error = error.response.data.errors;
            }

            if (error) {
              this.$swal({
                title: 'Failed',
                text: `Failed to fetch available ${type}`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#666',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Try again',
              }).then((result) => {
                if (result.value) {
                  this.fetchItem(type);
                }
              });
            }
          });
      });
    },

    flattenDestinations(data) {
      const result = [];
      let dataChild = [];
      if (this.form.type.value === 'domestic') {
        dataChild = data[0].child;
      } else {
        dataChild = data[1].child;
      }
      if (!data) return result;

      dataChild.forEach((parent) => {
        result.push({
          id: parent.id,
          label: parent.name,
        });
        if (parent.child) {
          parent.child.forEach((child) => {
            result.push({
              id: child.id,
              label: child.name,
            });
            if (child.child) {
              child.child.forEach((grandchild) => {
                result.push({
                  id: grandchild.id,
                  label: grandchild.name,
                });
              });
            }
          });
        }
      });

      return flatten(result);
    },
    levelDestinations(data) {
      if (!data) return [];
      let dataChild = [];
      if (this.form.type.value === 'domestic') {
        dataChild = data[0].child;
      } else {
        dataChild = data[1].child;
      }
      return dataChild.map((local) => {
        if (local.child) {
          return {
            id: local.id,
            label: local.name,
            isDefaultExpanded: true,
            children: local.child.map((parent) => {
              if (parent.child) {
                return {
                  id: parent.id,
                  label: parent.name,
                  children: parent.child.map(child => ({
                    id: child.id,
                    label: child.name,
                  })),
                };
              }

              return {
                id: parent.id,
                label: parent.name,
              };
            }),
          };
        }

        return {
          id: local.id,
          label: local.name,
        };
      });
    },

    async fetchDestination() {
      const destinations = await this.fetchItem('destinations');
      this.list.destinations = await this.levelDestinations(destinations);
      this.list.flatDestinations = await this.flattenDestinations(destinations);
    },

    isArray(array) {
      return Array.isArray(array);
    },

    setContentTabs(tabs) {
      if (!tabs) {
        return [
          {
            title: null,
            title_en: null,
            description: null,
            description_en: null,
          },
        ];
      }

      return tabs;
    },

    setContentPackages(packages) {
      if (!packages) {
        const emptyDate = [
          {
            from: null,
            to: null,
          },
        ];

        return [
          {
            sku_id: null,
            name: null,
            name_en: null,
            multiply: 1,
            description: null,
            description_en: null,
            age_max: 0,
            min_person: null,
            max_person: null,
            ticket: null,
            type: null,
            travel_date: (!this.isKlook) ? null : emptyDate,
            prices: [
              {
                base_cost: null,
                block_cost: {
                  type: 0,
                  value: null,
                },
                min_qty: 1,
                start_from: 1,
                source_price: null,
                exchange_rate: null,
                currency: null,
                price_per_type: 'pax',
                price_per_type_en: 'pax',
              },
            ],
          },
        ];
      }

      packages.forEach((item) => {
        item.ticket = this.mapValue(item.ticket.id, 'tickets');
        item.type = this.mapValue(item.type, 'type');

        // Fallback for Klook product with empty travel dates
        if (!item.travel_date) {
          item.travel_date = [
            {
              from: null,
              to: null,
            },
          ];
        }

        // Fallback for empty unit title
        if (item.prices) {
          item.prices.forEach((price) => {
            if (price.block_cost_percentage === 0) {
              price.block_cost = {
                type: 1,
                value: price.block_cost,
              };
            } else {
              price.block_cost = {
                type: 0,
                value: price.block_cost_percentage,
              };
            }

            if (!price.price_per_type) {
              price.price_per_type = 'pax';
            }

            if (!price.price_per_type_en) {
              price.price_per_type_en = 'pax';
            }
          });
        }
      });

      return packages;
    },

    parseDate(data) {
      if (!data || data === 'null') {
        return [
          {
            from: moment().format(this.config.date.iso),
            to: moment().format(this.config.date.iso),
          },
        ];
      }

      return JSON.parse(data);
    },

    compareMultiple(data, options, returnAsArray, selector) {
      const array = [];

      if (!Array.isArray(data)) {
        return array;
      }

      data.forEach((selected) => {
        this.list[options].forEach((item) => {
          if (item[selector] === selected.id) {
            array.push(item);
          }
        });
      });

      return array;
    },

    compareSingle(data, options, returnAsArray, selector) {
      let value = (returnAsArray) ? [] : null;

      this.list[options].forEach((item) => {
        if (item[selector] === data) {
          value = item;
        }
      });

      return value;
    },

    fullStartTime(startTime) {
      return `${startTime.HH}:${startTime.mm}:${startTime.ss}`;
    },

    fullEndTime(endTime) {
      return `${endTime.HH}:${endTime.mm}:${endTime.ss}`;
    },

    /**
     * [mapValue description]
     * @param  {[Object, Array]}   data          [description]
     * @param  {Array}             options       [description]
     * @param  {Boolean}           returnAsArray [description]
     * @param  {String}            selector      [description]
     * @return {[Object, Array]}
     */
    mapValue(data, options, returnAsArray = false, selector = 'value') {
      if (this.isArray(data)) {
        return this.compareMultiple(data, options, returnAsArray, selector);
      }

      return this.compareSingle(data, options, returnAsArray, selector);
    },

    setTime(dataTime, dataIfNull) {
      const time = dataTime || dataIfNull;
      const timeSplit = time.split(':');

      const timeFull = {
        HH: timeSplit[0],
        mm: timeSplit[1],
        ss: timeSplit[2],
      };

      return timeFull;
    },

    getLabelValueItem(dataArray) {
      if (!dataArray) return [];

      const dataList = [];
      dataArray.map(data => dataList.push({
        value: data.badge_id,
        label: data.badge_name,
      }));
      return dataList.filter(data => !!data.label);
    },

    setFormValue(data) {
      this.form.id = data.id;
      this.form.slug = data.slug;
      this.form.is_publish = data.is_publish;

      // Title
      this.form.name = data.name;
      this.form.name_en = data.name_en;

      // Details
      this.form.type = this.mapValue(data.type, 'region');
      const valueDestinations = data.destinations
      .filter(l => !data.destinations.find(val => l.id === val.parent_id))
      .map(l => l.id);
      this.form.destinations = valueDestinations;
      this.form.categories = this.mapValue(data.categories, 'categories');
      this.form.tags = this.mapValue(data.tags, 'tags', true);

      // Tags
      this.form.tags.can_be_canceled = data.can_be_canceled ? 0 : 1;
      this.form.tags.changed_voucher = data.changed_voucher ? 1 : 0;
      this.form.tags.duration_1_day = data.duration_1_day ? 1 : 0;
      this.form.tags.duration_2_day = data.duration_2_day ? 1 : 0;
      this.form.tags.require_confirmation = data.require_confirmation ? 1 : 0;
      // this.form.tags.is_fixed_date = data.is_fixed_date ? 1 : 0;
      // this.form.tags.is_open_date = data.is_open_date ? 1 : 0;
      // this.form.tags.calendar_display = data.calendar_display;

      // Conditions
      this.form.condition = this.mapValue(data.with_adult_is_must, 'condition');
      this.form.with_adult_is_must = data.with_adult_is_must;
      this.form.print_voucher = data.print_voucher ? 1 : 0;

      // Source
      this.form.merchant = this.mapValue(data.merchant_id, 'merchants');
      this.form.vendor = this.mapValue(data.vendor_id, 'vendors');
      this.form.product_code = data.product_code;

      // Bookings
      if (this.params.flaging === 'explore') {
        this.form.has_criteria = data.open_date === 1;
        this.form.open_date = data.open_date;
        this.form.fixed_date = data.fixed_date;
        this.form.valid_from = (data.valid_from) ? new Date(data.valid_from) : new Date();
        this.form.valid_to = (data.valid_to) ? new Date(data.valid_to) : new Date();
        this.form.booking.bookingDate = this.parseDate(data.booking_date);
        this.form.booking.travelDate = this.parseDate(data.travel_date);
        this.form.has_booking_duration = data.is_booking_duration === 1;
        this.form.has_travel_duration = data.is_travel_duration === 1;
        this.form.travel_duration = data.travel_duration;
        this.form.booking_duration = data.booking_duration;
        this.form.travel_duration_unit = this.mapValue(data.travel_duration_unit, 'travel_duration_unit');
        this.form.booking.start_time = this.setTime(data.start_time, '00:00:00');
        this.form.booking.end_time = this.setTime(data.end_time, '23:59:59');
        // this.form.require_confirmation = data.require_confirmation;
      } else {
        this.form.booking_tour.bookingOption = data.is_open_trip;
        this.form.booking_tour.bookingDuration = data.booking_duration.toString();
        this.form.booking_tour.bookingDate = this.parseDate(data.booking_date);
        this.form.booking_tour.travelDate = this.parseDate(data.travel_date);
        this.form.booking_tour.start_time = this.setTime(data.start_time, '00:00:00');
        this.form.booking_tour.end_time = this.setTime(data.end_time, '23:59:59');
      }

      // Package Section
      this.form.booking.packages = this.setContentPackages(data.prices);

      // Sequence and Badge
      this.form.sequence = data.sequence;
      this.form.badges = this.getLabelValueItem(data.badges);

      // Contents
      this.form.tabs = this.setContentTabs(data.tabs);

      // Content on E-Voucher
      if (this.params.flaging === 'explore') {
        this.form.vouchers[0].title = 'Instruksi Tiket';
        this.form.vouchers[0].title_en = 'Ticket Instruction';

        this.form.vouchers[1].title = 'Syarat dan Ketentuan';
        this.form.vouchers[1].title_en = 'Term and Conditions';
      } else {
        this.form.vouchers[0].title = 'Jadwal Perjalanan';
        this.form.vouchers[0].title_en = 'Itinerary';

        this.form.vouchers[1].title = 'Syarat dan Ketentuan';
        this.form.vouchers[1].title_en = 'Term and Conditions';
      }
      this.form.vouchers[0].description = data.how_to_use;
      this.form.vouchers[0].description_en = data.how_to_use_en;

      this.form.vouchers[1].description = data.terms_condition;
      this.form.vouchers[1].description_en = data.terms_condition_en;

      // Image & Gallery
      this.form.image.id = data.image_id;
      this.form.image.url = data.image_url;
      this.form.image_apps.id = data.image_apps_id;
      this.form.image_apps.url = data.image_apps_url;
      this.form.ticket_image.id = data.ticket_image_id;
      this.form.ticket_image.url = data.ticket_image_url;
      this.form.gallery = data.galleries;
      this.form.hide_breadcrumbs = data.hide_breadcrumbs;
      this.form.hide_searchbar = data.hide_searchbar;
      this.form.hide_recommendation = data.hide_recommendation;
    },

    fetchProduct() {
      return new Promise((resolve) => {
        const route = this.getApiRoute();
        this.axios.get(`${route}/${this.$route.params.id}`)
          .then((response) => {
            const { data } = response.data;

            // Data
            this.setFormValue(data);
            this.status_product = data.status_product;

            // State
            this.isLoading = false;
            this.checkStartFrom();

            if (this.status_product === 'Need Revision') {
              this.disableAllInput();
            }

            resolve();
          })
          .catch((error) => {
            console.log('Fetch product error', error);

            if (error.response) {
              this.error = error.response.data.errors;
            }

            if (error) {
              this.$swal({
                title: 'Failed',
                text: 'Failed to fetch product data',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#666',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Try again',
              }).then((result) => {
                if (result.value) {
                  this.fetchProduct();
                }
              });
            }
          });
      });
    },

    disableAllInput() {
      setTimeout(() => {
        this.vselect_disabled = true;
        const form = document.getElementById('product_id');
        const tags = ['input', 'button', 'select', 'textarea'];
        tags.forEach((tag) => {
          const inputs = form.getElementsByTagName(tag);

          for (let i = 0; i < inputs.length; i += 1) {
            inputs[i].disabled = true;
          }
        });
      });
    },

    async fetchAll() {
      await this.fetchDestination();
      await this.fetchItem('categories');
      await this.fetchItem('tags');
      await this.fetchItem('vendors');
      await this.fetchItem('merchants');
      await this.fetchItem('tags');
      await this.fetchItem('tickets');

      if (!this.isCreate) {
        await this.fetchProduct();
      } else {
        this.isLoading = false;
      }
    },

    getKlookPackageDate(index) {
      let date = moment().add(1, 'd').format('YYYY-MM-DD');

      const travelDate = this.form.booking.packages[index].travel_date;
      const firstTravelDate = travelDate[0];
      const lastTravelDate = travelDate[travelDate.length - 1];

      if (travelDate.length > 1 && lastTravelDate.to) {
        date = moment(lastTravelDate.to).format('YYYY-MM-DD');
      } else if (firstTravelDate.to) {
        date = moment(firstTravelDate.to).format('YYYY-MM-DD');
      }

      return date;
    },

    fetchKlookPrice(skuId, index) {
      if (!skuId) return;

      this.klookLoading = true;

      const date = this.getKlookPackageDate(index);

      this.axios.get(`/klook/price?product_id=${this.form.product_code}&sku_id=${skuId}&date=${date}`)
        .then((response) => {
          const { price, title, rate, currency } = response.data;

          this.form.booking.packages[index].sku_title = title;

          this.form.booking.packages[index].prices.forEach((item) => {
            item.source_price = price;
            item.exchange_rate = rate;
            item.currency = currency;

            const total = rate * price;
            item.base_cost = Math.ceil(total.toFixed(2));
          });

          this.klookLoading = false;
        })
        .catch((error) => {
          console.log('Fetch Klook price error', error);
          this.klookLoading = false;
        });
    },

    resetFormOptions() {
      return new Promise((resolve) => {
        this.optionForm.categories.name = null;
        this.optionForm.categories.name_en = null;
        this.optionForm.categories.slug = null;
        this.optionForm.categories.image = {
          id: null,
          url: null,
        };

        this.optionForm.destinations.name = null;
        this.optionForm.destinations.slug = null;
        this.optionForm.destinations.parent = null;
        this.optionForm.destinations.image = {
          id: null,
          url: null,
        };

        resolve();
      });
    },

    addOption(type) {
      let data;

      if (type === 'categories') {
        data = {
          name: this.optionForm.categories.name,
          name_en: this.optionForm.categories.name_en,
          slug: this.optionForm.categories.slug,
          image: parseInt(this.optionForm.categories.image.id, 10),
        };
      }

      if (type === 'destinations') {
        data = {
          name: this.optionForm.destinations.name,
          slug: this.optionForm.destinations.slug,
          parent_id: parseInt(this.optionForm.destinations.parent.id, 10),
          image: parseInt(this.optionForm.destinations.image.id, 10),
        };
      }

      this.axios.post(`/${type}`, this.stringify(data))
        .then(() => {
          if (type === 'destinations') {
            this.list.destinations = null;

            this.$nextTick(() => {
              this.fetchDestination();
              this.resetFormOptions();
              this.closeModals();
            });
          } else {
            this.fetchItem(type);
            this.resetFormOptions();
            this.closeModals();
          }
        })
        .catch((error) => {
          console.log('error', error);

          if (error.response) {
            this.error = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Create Failed!',
              text: `Failed to create new ${type}`,
              type: 'warning',
              timer: 3000,
            });
          }
        });
    },

    setPriceStartFrom(index, priceIndex) {
      this.form.booking.packages.map((vpackage, ipackage) => {
        this.form.booking.packages[ipackage].prices.map((price) => {
          price.start_from = 0;
          return true;
        });
        return true;
      });
      this.form.booking.packages[index].prices[priceIndex].start_from = 1;
    },

    addItem(type, index) {
      if (type === 'package') {
        this.form.booking.packages.push({
          sku_id: null,
          sku_title: null,
          name: null,
          name_en: null,
          multiply: 1,
          description: null,
          description_en: null,
          age_max: 0,
          ticket: null,
          max_person: null,
          min_person: null,
          type: null,
          travel_date: [
            {
              from: null,
              to: null,
            },
          ],
          prices: [
            {
              base_cost: null,
              block_cost: {
                type: 0,
                value: null,
              },
              min_qty: 1,
              start_from: 0,
              source_price: null,
              exchange_rate: null,
              currency: null,
              price_per_type: 'pax',
              price_per_type_en: 'pax',
              gimmick_price: null,
            },
          ],
        });
      }

      if (type === 'price') {
        this.form.booking.packages[index].prices.push({
          base_cost: null,
          block_cost: {
            type: 0,
            value: null,
          },
          min_qty: 1,
          start_from: 0,
          source_price: null,
          exchange_rate: null,
          currency: null,
          price_per_type: 'pax',
          price_per_type_en: 'pax',
          gimmick_price: null,
        });
        if (this.isKlook) {
          this.fetchKlookPrice(this.form.booking.packages[index].sku_id, index);
        }
      }

      let booking = null;
      if (this.params.flaging === 'explore') {
        booking = this.form.booking;
      } else {
        booking = this.form.booking_tour;
      }

      if (type === 'booking') {
        booking.bookingDate.push({
          from: null,
          to: null,
        });
      }

      if (type === 'travel') {
        booking.travelDate.push({
          from: null,
          to: null,
        });
      }

      if (type === 'klook-travel') {
        booking.packages[index].travel_date.push({
          from: null,
          to: null,
        });
      }
    },

    removeItem(item, object, itemIndex) {
      this.$swal({
        title: 'Delete Item',
        text: 'Are you sure to delete this item?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#666',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          if (object === 'packages') {
            const index = this.form.booking.packages.indexOf(item);
            this.form.booking.packages.splice(index, 1);
          } else if (object === 'price') {
            const index = this.form.booking.packages.indexOf(item);
            this.form.booking.packages[index].prices.splice(itemIndex, 1);
          } else if (object === 'booking') {
            let booking = null;
            if (this.params.flaging === 'explore') {
              booking = this.form.booking;
            } else {
              booking = this.form.booking_tour;
            }
            const index = booking.bookingDate.indexOf(item);
            booking.bookingDate.splice(index, 1);
          } else if (object === 'travel') {
            let booking = null;
            if (this.params.flaging === 'explore') {
              booking = this.form.booking;
            } else {
              booking = this.form.booking_tour;
            }
            const index = booking.travelDate.indexOf(item);
            booking.travelDate.splice(index, 1);
          } else if (object === 'klook-travel') {
            const index = this.form.booking.packages.indexOf(item);
            this.form.booking.packages[index].travel_date.splice(itemIndex, 1);
          } else {
            const index = this.form[object].indexOf(item);
            this.form[object].splice(index, 1);
          }
        }
      });
    },

    publishRate(index, priceIndex) {
      const baseCost = this.form.booking.packages[index].prices[priceIndex].base_cost;
      const blockCost = this.form.booking.packages[index].prices[priceIndex].block_cost;
      if (!baseCost || !blockCost.value) return null;

      let price = 0;
      const baseCostInt = parseInt(baseCost, 10);
      const blockCostInt = parseInt(blockCost.value, 10);
      if (blockCost.type === 0) {
        price = baseCostInt + ((baseCostInt / 100) * blockCostInt);
      } else {
        price = baseCostInt + blockCostInt;
      }
      return numeral(price).format('0,0');
    },

    setImage(payload) {
      if (payload.target === 'featured') {
        this.form.image = payload.images;
      }

      if (payload.target === 'featured_apps') {
        this.form.image_apps = payload.images;
      }

      if (payload.target === 'gallery') {
        this.form.gallery = payload.images;
      }

      if (payload.target === 'category') {
        this.optionForm.categories.image = payload.images;
      }

      if (payload.target === 'destinations') {
        this.optionForm.destinations.image = payload.images;
      }

      if (payload.target === 'ticket_image') {
         this.form.ticket_image = payload.images;
      }

      // if (payload.target === 'logo') {
      //   this.form.logo = payload.images;
      // }

      // if (payload.target === 'moods') {
      //   this.optionForm.moods.image = payload.images;
      // }
    },

    getDisabledDate(index, type) {
      const today = moment().subtract(1, 'd').toDate();
      let to = null;

      if (this.booking[type][index].to) {
        to = moment(this.booking[type][index].to).toDate();
      }

      return {
        to: (this.booking[type][index].to) ? to : today,
      };
    },

    async loadOptions({ action }) {
      if (action === LOAD_ROOT_OPTIONS) {
        if (this.destinationListUpdated) {
          await this.fetchDestination();
          this.destinationListUpdated = false;
        }
      }
    },

    checkUrl(url) {
      if (!url) return '';
      const absoluteUrl = (url.includes('https://')) ? url : `https://${url}`;
      return absoluteUrl;
    },

    showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },

    closeModals() {
      document.body.classList.remove('locked');
      Object.keys(this.show).forEach((modal) => {
        this.show[modal] = false;
      });
    },

    isBefore(dateBefore, dateAfter) {
      const fromBefore = moment(dateBefore);
      const fromAfter = moment(dateAfter);
      return fromBefore.isAfter(fromAfter, 'day');
    },

    validateForm() {
      /* eslint-disable camelcase */
      if (!this.form.name) {
        this.$swal('Name required', 'Please fill product Name', 'warning');
        return false;
      }

      if (!this.form.name_en) {
        this.$swal('Name En required', 'Please fill product Name En', 'warning');
        return false;
      }

      // Detail Section
      if (!this.form.type) {
        this.$swal('Travel type required', 'Please select travel type', 'warning');
        return false;
      }

      if (!this.form.destinations || this.form.destinations.length < 1) {
        this.$swal('Destination required', 'Please select at least one destination', 'warning');
        return false;
      }
      if (this.form.destinations && this.form.destinations.length > 3) {
        this.$swal('Please update destinations', 'You can only choose one city as destinations', 'warning');
        return false;
      }

      if (!this.form.categories || this.form.categories.length < 1) {
        this.$swal('Categories required', 'Please select at least one category', 'warning');
        return false;
      }

      if (!this.form.tags || this.form.tags.length < 1) {
        this.$swal('Tags required', 'Please select at least one tag', 'warning');
        return false;
      }

      // Source Section
      if (!this.isKlook) {
        if (!this.form.merchant) {
          this.$swal('Merchant required', 'Please select merchant', 'warning');
          return false;
        }
      }

      if (!this.form.vendor) {
        this.$swal('Source required', 'Please select source', 'warning');
        return false;
      }

      if (this.isKlook) {
        if (!this.form.product_code) {
          this.$swal('Product code required', 'Please fill Klook product code', 'warning');
          return false;
        }
      }

      // Booking Section
      if (this.params.flaging === 'explore') {
        if (this.form.has_criteria) {
          const dateBetweenValidation = moment(this.form.valid_to).isAfter(this.form.valid_from, 'day');
          if (!this.form.valid_from) {
            this.$swal('Booking Criteria required', 'Please fill Booking Criteria from', 'warning');
            return false;
          }
          if (!this.form.valid_to) {
            this.$swal('Booking Criteria required', 'Please fill Booking Criteria to', 'warning');
            return false;
          }
          if (!dateBetweenValidation) {
            this.$swal('Booking Criteria Invalid', '"Booking Criteria to" is before "Booking Criteria from"', 'warning');
            return false;
          }
        }

        if (this.form.is_booking_duration === 0) {
          for (let bI = 0; bI < this.form.booking.bookingDate.length; bI += 1) {
            const { from, to } = this.form.booking.bookingDate[bI];
            const dateBetweenValidation = moment(to).isAfter(from, 'day');

            if (!from) {
              this.$swal('Booking Date required', 'Please fill Booking Date from', 'warning');
              return false;
            }

            if (!to) {
              this.$swal('Booking Date required', 'Please fill Booking Date to', 'warning');
              return false;
            }

            if (!dateBetweenValidation) {
              this.$swal('Booking Date Invalid', '"Booking date to" is before "Booking date from"', 'warning');
              return false;
            }
          }
        }

        if (!this.isKlook) {
          for (let bD = 0; bD < this.form.booking.bookingDate.length; bD += 1) {
            const { from, to } = this.form.booking.bookingDate[bD];
            const dateBetweenValidation = moment(to).isSameOrAfter(from, 'day');

            if (!from) {
              this.$swal('Booking Date required', 'Please fill Booking Date from', 'warning');
              return false;
            }

            if (!to) {
              this.$swal('Booking Date required', 'Please fill Booking Date to', 'warning');
              return false;
            }

            if (!dateBetweenValidation) {
              this.$swal('Booking Date Invalid', '"Booking date to" is before "Booking date from"', 'warning');
              return false;
            }
          }

          for (let bI = 0; bI < this.form.booking.travelDate.length; bI += 1) {
            const { from, to } = this.form.booking.travelDate[bI];
            const dateBetweenValidation = moment(to).isSameOrAfter(from, 'day');

            if (!from) {
              this.$swal('Travel Date required', 'Please fill Travel Date from', 'warning');
              return false;
            }

            if (!to) {
              this.$swal('Travel Date required', 'Please fill Travel Date to', 'warning');
              return false;
            }

            if (!dateBetweenValidation) {
              this.$swal('Travel Date Invalid', '"Travel date to" is before "Travel date from"', 'warning');
              return false;
            }
          }
        }

        if (this.form.has_travel_duration === true && this.form.travel_duration <= 0) {
          this.$swal('Travel duration must greater than 0');
          return false;
        }

        if (!this.isKlook) {
          for (let ii = 0; ii < this.form.booking.bookingDate.length; ii += 1) {
            if (this.form.booking.bookingDate.length - 1 !== ii) {
              const fromBefore = this.form.booking.bookingDate[ii].to;
              const fromAfter = this.form.booking.bookingDate[ii + 1].from;
              const isNotValid = this.isBefore(fromBefore, fromAfter);

              if (isNotValid) {
                this.$swal({
                  type: 'error',
                  title: 'Date Not Valid',
                  text: 'Please readjust booking dates. Booking date before is larger than booking date after',
                });

                return false;
              }
            }
          }

          for (let it = 0; it < this.form.booking.travelDate.length; it += 1) {
            if (this.form.booking.travelDate.length - 1 !== it) {
              const fromBefore = this.form.booking.travelDate[it].to;
              const fromAfter = this.form.booking.travelDate[it + 1].from;
              const isNotValid = this.isBefore(fromBefore, fromAfter);

              if (isNotValid) {
                this.$swal({
                  type: 'error',
                  title: 'Date Not Valid',
                  text: 'Please readjust travel dates. Travel date before is larger than travel date after',
                });

                return false;
              }
            }
          }
        }

        const startTime = moment(this.fullStartTime(this.form.booking.start_time), 'HH:mm:ss');
        const endTime = moment(this.fullEndTime(this.form.booking.end_time), 'HH:mm:ss');

        if (endTime.isBefore(startTime)) {
          this.$swal('Booking time invalid', 'Please choose correct end time to continue', 'warning');
          return false;
        }
      } else {
        if (!this.form.booking_tour.bookingDuration) {
          this.$swal('Booking Duration required', 'Please fill Booking Duration', 'warning');
          return false;
        }

        for (let bD = 0; bD < this.form.booking_tour.bookingDate.length; bD += 1) {
          const { from, to } = this.form.booking_tour.bookingDate[bD];
          const dateBetweenValidation = moment(to).isSameOrAfter(from, 'day');

          if (!from) {
            this.$swal('Booking Date required', 'Please fill Booking Date from', 'warning');
            return false;
          }

          if (!to) {
            this.$swal('Booking Date required', 'Please fill Booking Date to', 'warning');
            return false;
          }

          if (!dateBetweenValidation) {
            this.$swal('Booking Date Invalid', '"Booking date to" is before "Booking date from"', 'warning');
            return false;
          }
        }

        for (let bI = 0; bI < this.form.booking_tour.travelDate.length; bI += 1) {
          const { from, to } = this.form.booking_tour.travelDate[bI];
          const dateBetweenValidation = moment(to).isSameOrAfter(from, 'day');

          if (!from) {
            this.$swal('Travel Date required', 'Please fill Travel Date from', 'warning');
            return false;
          }

          if (!to) {
            this.$swal('Travel Date required', 'Please fill Travel Date to', 'warning');
            return false;
          }

          if (!dateBetweenValidation) {
            this.$swal('Travel Date Invalid', '"Travel date to" is before "Travel date from"', 'warning');
            return false;
          }
        }
      }
      // Package Section
      for (let paI = 0; paI < this.form.booking.packages.length; paI += 1) {
        const {
          name,
          name_en,
          description,
          description_en,
          multiply,
          type,
          min_person,
          max_person,
          sku_id,
          ticket,
          travel_date,
        } = this.form.booking.packages[paI];

        if (!name) {
          this.$swal('Package name required', 'Please fill package name', 'warning');
          return false;
        }

        if (!name_en) {
          this.$swal('Package name required', 'Please fill english package name', 'warning');
          return false;
        }

        if (!description) {
          this.$swal('Package description required', 'Please fill package description', 'warning');
          return false;
        }

        if (!description_en) {
          this.$swal('Package description required', 'Please fill english package description', 'warning');
          return false;
        }

        if (!multiply || multiply < 0) {
          this.$swal('Package multiplier required', 'Please set package multiplier', 'warning');
          return false;
        }

        if (!type) {
          this.$swal('Package type required', 'Please select package type', 'warning');
          return false;
        }

        if (!min_person || min_person < 0) {
          this.$swal('Package min person required', 'Please fill package min person', 'warning');
          return false;
        }

        if (!max_person || max_person < 0) {
          this.$swal('Package max person required', 'Please fill package max person', 'warning');
          return false;
        }

        if (parseInt(min_person, 10) > parseInt(max_person, 10)) {
          this.$swal('Package person Invalid', 'Min person is greater than max person', 'warning');
          return false;
        }

        if (!ticket && !this.isKlook) {
          this.$swal('Ticket inventory required', 'Please select ticket inventory', 'warning');
          return false;
        }

        if (this.isKlook) {
          if (!sku_id) {
            this.$swal('Package SKU ID required', 'Please fill package SKU ID', 'warning');
            return false;
          }

          for (let bI = 0; bI < travel_date.length; bI += 1) {
            const { from, to } = travel_date[bI];
            const dateBetweenValidation = moment(to).isSameOrAfter(from, 'day');

            if (!from) {
              this.$swal('Travel Date required', 'Please fill Travel Date from', 'warning');
              return false;
            }

            if (!to) {
              this.$swal('Travel Date required', 'Please fill Travel Date to', 'warning');
              return false;
            }

            if (!dateBetweenValidation) {
              this.$swal('Travel Date Invalid', '"Travel date to" is before "Travel date from"', 'warning');
              return false;
            }
          }

          if (travel_date.length === this.form.booking.bookingDate.length) {
            for (let bI = 0; bI < travel_date.length; bI += 1) {
              const bookingDateTo = moment(this.form.booking.bookingDate[bI].to).format('YYYY-MM-DD');
              const bookingDateFrom = moment(this.form.booking.bookingDate[bI].from).format('YYYY-MM-DD');
              const travelDateTo = moment(this.form.booking.packages[paI].travel_date[bI].to).format('YYYY-MM-DD');
              const travelDateFrom = moment(this.form.booking.packages[paI].travel_date[bI].from).format('YYYY-MM-DD');
              const isSameTo = moment(bookingDateTo).isSame(travelDateTo);
              const isSameFrom = moment(bookingDateFrom).isSame(travelDateFrom);
              const isNotValidTo = this.isBefore(bookingDateTo, travelDateTo);
              const isNotValidFrom = this.isBefore(bookingDateFrom, travelDateFrom);

              if (isNotValidTo) {
                this.$swal({
                  type: 'error',
                  title: 'Date Not Valid',
                  text: 'Please readjust booking dates. Travel date to is larger than booking date to',
                });

                return false;
              }

              if (isNotValidFrom) {
                this.$swal({
                  type: 'error',
                  title: 'Date Not Valid',
                  text: 'Please readjust booking dates. Travel date from is larger than booking date from',
                });

                return false;
              }

              if (isSameFrom) {
                this.$swal({
                  type: 'error',
                  title: 'Date Not Valid',
                  text: 'Please readjust travel dates. Travel date from cannot is same booking date from',
                });

                return false;
              }

              if (isSameTo) {
                this.$swal({
                  type: 'error',
                  title: 'Date Not Valid',
                  text: 'Please readjust travel dates. Travel date to cannot is same booking date to',
                });

                return false;
              }
            }
          }
        }

        for (let piI = 0; piI < this.form.booking.packages[paI].prices.length; piI += 1) {
          const {
            base_cost,
            block_cost,
            min_qty,
            source_price,
            currency,
            exchange_rate,
          } = this.form.booking.packages[paI].prices[piI];

          if (!base_cost || base_cost === '0' || parseInt(base_cost, 10) < 1) {
            this.$swal('Package nett price required', 'Please set package nett price. Minimum nett price is 1', 'warning');
            return false;
          }

          if ((!block_cost.value && parseInt(block_cost.value, 10) < 0) || block_cost.value === '') {
            this.$swal('Package commission required', 'Please set package commission price. Minimum comission is 0', 'warning');
            return false;
          }

          if (!min_qty) {
            this.$swal('Package Quantity required', 'Please set package minimum quantity', 'warning');
            return false;
          }

          if (!base_cost && !min_qty) {
            this.$swal('Package detail required', 'Please fill package contents', 'warning');
            return false;
          }

          if (this.isKlook) {
            if (!source_price) {
              this.$swal('Package source price required', 'Please fill package source price', 'warning');
              return false;
            }

            if (!currency) {
              this.$swal('Package currency required', 'Please fill package currency', 'warning');
              return false;
            }

            if (!exchange_rate) {
              this.$swal('Package exchange rate required', 'Please fill package exchange rate', 'warning');
              return false;
            }
          }
        }
      }

      this.checkStartFrom();
      if (!this.hasStartFrom) {
        this.$swal('Start from is required', 'Please select a \'start from\' from the price list', 'warning');
        return false;
      }

      // Sequence and Badge
      if (!this.form.sequence) {
        this.$swal('Sequence is required', 'Please fill the sequence', 'warning');
        return false;
      }

      // Content Tabs Section
      for (let i = 0; i < this.form.tabs.length; i += 1) {
        const { title, description, title_en, description_en } = this.form.tabs[i];

        if (!title) {
          this.$swal('Tab required', 'Please fill tab indonesia title', 'warning');
          return false;
        }

        if (!description) {
          this.$swal('Tab required', 'Please fill tab indonesia description', 'warning');
          return false;
        }

        if (!title_en) {
          this.$swal('Tab required', 'Please fill tab englsih title', 'warning');
          return false;
        }

        if (!description_en) {
          this.$swal('Tab required', 'Please fill tab englsih description', 'warning');
          return false;
        }

        if (!title && !description && !title_en && !description_en) {
          this.$swal('Tab required', 'Please fill uncomplete content', 'warning');
          return false;
        }
      }

      // E-vouchers Section
      for (let i = 0; i < this.form.vouchers.length; i += 1) {
        const { title, description, title_en, description_en } = this.form.vouchers[i];

        if (!title) {
          this.$swal('Content on E-Voucher required', 'Please fill Content on E-Voucher indonesia title', 'warning');
          return false;
        }

        if (!description) {
          this.$swal('Content on E-Voucher required', 'Please fill Content on E-Voucher indonesia description', 'warning');
          return false;
        }

        if (!title_en) {
          this.$swal('Content on E-Voucher required', 'Please fill Content on E-Voucher englsih title', 'warning');
          return false;
        }

        if (!description_en) {
          this.$swal('Content on E-Voucher required', 'Please fill Content on E-Voucher englsih description', 'warning');
          return false;
        }

        if (!title && !description && !title_en && !description_en) {
          this.$swal('Content on E-Voucher required', 'Please fill uncomplete content', 'warning');
          return false;
        }
      }

      // Image Section
      // if (!(this.form.image.id.toString())) {
      //   this.$swal('Thumbnail required', 'Please choose product image', 'warning');
      //   return false;
      // }

      // if (!this.form.image_apps.id.toString()) {
      //   this.$swal('Thumbnail apps required', 'Please choose product image apps', 'warning');
      //   return false;
      // }

      if (!this.form.gallery || this.form.gallery.length < 1) {
        this.$swal('Image Gallery Required', 'Please select at least one Image Gallery', 'warning');
        return false;
      }

      /* eslint-enable camelcase */
      return true;
    },

    setErrors(error, mode) {
      console.error(`${mode} error`, error);

      this.isSubmitting = false;

      if (error.response) {
        this.error = error.response.data.errors;
      }

      if (error) {
        let message = `Failed to ${mode} Product`;

        if (this.error) {
          message = this.error;
        }

        this.$swal({
          title: `${mode} Failed!`,
          text: message,
          type: 'error',
          timer: 5000,
          onClose: () => {
            this.error = null;
          },
        });
      }
    },

    showErrorModal(errors) {
      let string = '';

      if (Object.keys(errors).length > 0) {
        Object.keys(errors).forEach((key, value) => {
          string += `${key} ${value}, `;
        });
      }

      this.$swal('Data required', string, 'warning');
    },

    checkStartFrom() {
      this.form.booking.packages.map((vpackage, ipackage) => {
        if (this.form.booking.packages[ipackage].prices) {
          this.form.booking.packages[ipackage].prices.map((price) => {
            this.hasStartFrom += price.start_from;
            return true;
          });
        }
        return true;
      });
    },

    generateDisabledDate(target, index = 0, indexPackage = 0, type = null) {
      let date = null;
      let to = null;

      /**
       * Only for booking criteria
       */
      if (target === 'valid_to') {
        return {
          to: moment(this.form.valid_from).add(1, 'days').toDate(),
        };
      }

      /**
       * Only for Klook Travel Date
       */
      if (target === 'klook') {
        to = moment().toDate();

        if (index < 1 && type === 'to') {
          date = this.form.booking.packages[indexPackage].travel_date[index].from;
          to = moment(date).toDate();
        }

        if (index > 0 && type === 'from') {
          date = this.form.booking.packages[indexPackage].travel_date[index - 1].to || null;

          if (!date) {
            date = this.form.booking.packages[indexPackage].travel_date[index - 1].from || null;
          }

          if (!date) {
            date = moment().toDate();
          }

          to = moment(date).add(1, 'd').toDate();
        }

        if (type === 'to') {
          date = this.form.booking.packages[indexPackage].travel_date[index].from || null;

          // Fallback if last fromDate also not yet filled
          if (!date) {
            date = moment().toDate();
          }

          to = moment(date).add(1, 'days').toDate();
        }

        return {
          to,
        };
      }

      /**
       * Set default: from today
       */

      let booking = null;
      if (this.params.flaging === 'explore') {
        booking = this.form.booking;
      } else {
        booking = this.form.booking_tour;
      }

      if (index < 1 && type === 'from') {
        return {
          to: moment().subtract(1, 'd').toDate(),
        };
      }

      /**
       * Get first fromDate
       */
      if (index < 1 && type === 'to') {
        date = booking[target][index].from;

        return {
          to: moment(date).toDate(),
        };
      }

      /**
       * Get toDate from the previous array
       */
      if (index > 0 && type === 'from') {
        date = booking[target][index - 1].to || null;

        // Fallback if last toDate not yet filled
        if (!date) {
          date = booking[target][index - 1].from || null;
        }

        // Fallback if last fromDate also not yet filled
        if (!date) {
          date = moment().toDate();
        }

        return {
          to: moment(date).add(1, 'd').toDate(),
        };
      }

      /**
       * Get fromDate from the previous array
       */
      if (type === 'to') {
        date = booking[target][index].from || null;

        // Fallback if last fromDate also not yet filled
        if (!date) {
          date = moment().toDate();
        }

        return {
          to: moment(date).toDate(),
        };
      }

      /**
       * Return default disabled date
       */
      return this.configs.datepicker.disabled;
    },

    openDateFromMinDate(target, index, type) {
      let date = null;

      let booking = null;
      if (this.params.flaging === 'explore') {
        booking = this.form.booking;
      } else {
        booking = this.form.booking_tour;
      }

      if (index > 0) {
        if (type === 'from') {
          date = booking[target][index - 1].to || null;
        }

        if (type === 'to') {
          date = booking[target][index].from || null;
        }
      }

      return (date) ? moment(date).toDate() : moment().toDate();
    },

    generatePreview(slug, id) {
      if (!slug) return '';
      const basePreviewPath = WEB_URL || 'https://www.misteraladin.com/aladintravel/aladinxplore';
      return `${basePreviewPath}/product/${slug}-${id}?preview=true`;
    },

    generateDates(array, returnAsString = true, subtract = false) {
      if (!array) return null;

      const data = [];

      if (!subtract) {
        array.forEach((item) => {
          data.push({
            from: moment(item.from).format(this.config.date.iso),
            to: moment(item.to).format(this.config.date.iso),
          });
        });
      } else {
        array.forEach((item) => {
          data.push({
            from: moment(item.from).format(this.config.date.iso),
            to: moment(item.to).format(this.config.date.iso),
          });
        });
      }

      if (!returnAsString) {
        return data;
      }

      return JSON.stringify(data);
    },

    generatePackages(data) {
      const packages = [];

      data.forEach((item) => {
        const prices = [];

        item.prices.forEach((itemPrice) => {
          prices.push({
            base_cost: parseInt(itemPrice.base_cost, 10),
            block_cost: this.calculateBlockCost(itemPrice.base_cost, itemPrice.block_cost),
            block_cost_percentage: itemPrice.block_cost.type === 0 ?
                                   parseInt(itemPrice.block_cost.value, 10) : null,
            gimmick_price: parseInt(itemPrice.gimmick_price, 10),
            min_qty: parseInt(itemPrice.min_qty, 10),
            start_from: parseInt(itemPrice.start_from, 10),
            source_price: parseFloat(itemPrice.source_price),
            exchange_rate: parseFloat(itemPrice.exchange_rate),
            currency: itemPrice.currency,
            price_per_type: itemPrice.price_per_type,
            price_per_type_en: itemPrice.price_per_type_en,
          });
        });

        packages.push({
          sku_id: item.sku_id,
          name: item.name,
          name_en: item.name_en,
          description: item.description,
          description_en: item.description_en,
          multiply: parseInt(item.multiply, 10),
          min_person: parseInt(item.min_person, 10),
          max_person: parseInt(item.max_person, 10),
          ticket_id: (!this.isKlook) ? item.ticket.value : 0,
          travel_date: (this.isKlook) ? this.generateDates(item.travel_date, false) : null,
          type: item.type.value,
          prices,
        });
      });

      return JSON.stringify(packages);
    },

    calculateBlockCost(baseCost, blockCost) {
      const baseCostInt = parseInt(baseCost, 10);
      const blockCostInt = parseInt(blockCost.value, 10);
      let blockCostReturn = 0;
      if (blockCost.type === 0) {
        blockCostReturn = (baseCostInt / 100) * blockCostInt;
      } else {
        blockCostReturn = blockCostInt;
      }
      return Math.ceil(blockCostReturn);
    },

    generateTabs(tabs) {
      const data = tabs.map((tab, index) => ({
        ...tab,
        seq: index,
      }));

      return data;
    },

    generateData() {
      /* eslint-disable camelcase, no-unused-vars, object-shorthand, max-len */
      const {
        booking,
        badges,
        booking_duration,
        categories,
        condition,
        destinations,
        fixed_date,
        gallery,
        has_booking_duration,
        has_travel_duration,
        id,
        image,
        image_apps,
        is_publish,
        merchant,
        name,
        name_en,
        open_date,
        product_code,
        print_voucher,
        slug,
        tabs,
        tags,
        type,
        travel_duration,
        travel_duration_unit,
        has_criteria,
        valid_from,
        valid_to,
        vendor,
        visibility,
        with_adult_is_must,
        ticket_image,
        booking_tour,
        sequence,
        vouchers,
        hide_breadcrumbs,
        hide_searchbar,
        hide_recommendation,
      } = this.form;

      const data = {};

      // Data
      data.slug = !slug ? this.toSlug(name) : slug;
      data.is_publish = (is_publish) ? 1 : 0;
      data.visibility = (visibility) ? 1 : 0;
      data.type_product = this.params.flaging;
      data.hide_breadcrumbs = hide_breadcrumbs;
      data.hide_searchbar = hide_searchbar;
      data.hide_recommendation = hide_recommendation;

      // Title
      data.name = name;
      data.name_en = name_en;

      // Details
      data.type = type.value;
      data.destinations = JSON.stringify(destinations.map(Number));
      data.categories = JSON.stringify(categories.map(item => (item.value)));
      data.tags = JSON.stringify(tags.map(item => (item.value)));

      // Tags
      data.require_confirmation = (tags.require_confirmation) ? 1 : 0;
      data.can_be_canceled = (tags.can_be_canceled) ? 0 : 1;
      data.duration_1_day = (tags.duration_1_day) ? 1 : 0;
      data.duration_2_day = (tags.duration_2_day) ? 1 : 0;
      data.changed_voucher = (tags.changed_voucher) ? 1 : 0;

      /**
       * Condition Start - Da fuck is these shit!!!!????
       * @type {integer}
       */
      data.with_adult_is_must = (condition.value === 1) ? 1 : 0;
      data.no_need_specific_condition = (condition.value === 1) ? 0 : 1;
      /**
       * Condition End - Da fuck is these shit!!!!????
       */

      data.print_voucher = (print_voucher) ? 1 : 0;

      // Source
      data.vendor = (vendor) ? vendor.value : null;
      data.merchant_id = (merchant) ? merchant.value : null;

      // Klook
      data.product_code = product_code;

      if (this.params.flaging === 'explore') {
        // Booking Open Date
        data.open_date = has_criteria ? 1 : 0;
        data.fixed_date = has_criteria ? 0 : 1;
        data.valid_from = (open_date) ? moment(valid_from).format(this.config.date.iso) : null;
        data.valid_to = (open_date) ? moment(valid_to).format(this.config.date.iso) : null;

        /**
         * Booking duration Start - Da fuck is these shit!!!!????
         * @type {integer}
         */
        data.is_booking_duration = (has_booking_duration) ? 1 : 0;
        data.no_is_booking_duration = (has_booking_duration) ? 0 : 1;
        /**
         * Booking duration End - Da fuck is these shit!!!!????
         */

        data.booking_duration = has_booking_duration ? booking_duration : 0;
        data.booking_duration_unit = 'day';

        /**
         * Travel duration Start - Da fuck is these shit!!!!????
         * @type {integer}
         */
        data.is_travel_duration = (has_travel_duration) ? 1 : 0;
        data.no_is_travel_duration = (has_travel_duration) ? 0 : 1;
        /**
         * Travel duration End - Da fuck is these shit!!!!????
         */

        data.travel_duration = has_travel_duration ? travel_duration : 0;
        data.travel_duration_unit = has_travel_duration ? travel_duration_unit.value : null;

        // Bookings
        data.booking_date = this.generateDates(booking.bookingDate);
        data.travel_date = this.generateDates(booking.travelDate);
        data.start_time = this.fullStartTime(booking.start_time);
        data.end_time = this.fullEndTime(booking.end_time);
      } else {
        // Booking Tour
        data.is_open_trip = booking_tour.bookingOption;
        data.booking_duration = booking_tour.bookingDuration;
        data.booking_duration_unit = 'day';
        data.booking_date = this.generateDates(booking_tour.bookingDate);
        data.travel_date = this.generateDates(booking_tour.travelDate);
        data.start_time = this.fullStartTime(booking_tour.start_time);
        data.end_time = this.fullStartTime(booking_tour.end_time);
      }

      // Packages/Prices/Persons
      data.persons = this.generatePackages(booking.packages);

      // Sequence and Badges
      data.sequence = parseInt(sequence, 10);
      if (!this.isCreate) {
        data.badges = JSON.stringify(badges.map(item => (item.value)));
      }

      // Tabs
      data.tabs = JSON.stringify(this.generateTabs(tabs));

      // E-Vouchers
      data.how_to_use_title = vouchers[0].title;
      data.how_to_use_title_en = vouchers[0].title_en;
      data.how_to_use = vouchers[0].description;
      data.how_to_use_en = vouchers[0].description_en;

      data.terms_condition_title = vouchers[1].title;
      data.terms_condition_title_en = vouchers[1].title_en;
      data.terms_condition = vouchers[1].description;
      data.terms_condition_en = vouchers[1].description_en;

      // Image & Gallery
      data.image = (image) ? image.id : null;
      data.image_apps = (image_apps) ? image_apps.id : null;
      data.ticket_image = (ticket_image) ? ticket_image.id : null;
      data.galleries = (gallery) ? JSON.stringify(gallery.map(item => (item.id))) : null;
      // logo: logoData,

      // Product status
      if (this.isCreate) {
        data.status_product = 'Approved';
      }

      return this.stringify(data);
      /* eslint-enable camelcase, no-unused-vars, object-shorthand, max-len */
    },

    submit(action) {
      if (!this.validateForm()) return;
      this.isSubmitting = true;

      const data = this.generateData();

      if (this.isCreate) {
        this.create(data);
      } else {
        if (this.status_product === 'Need Approval') {
          this.confirmStatusChange(action, data);
        }
        if (this.status_product === 'Approved') {
          this.update(data);
        }
      }
    },

    getApiRoute() {
      let route = '';
      if (this.params.flaging === 'tour') {
        route = '/products-tour';
      } else {
        route = '/products';
      }
      return route;
    },

    create(data) {
      const route = this.getApiRoute();
      return this.axios.post(route, data)
        .then((response) => {
          const productId = response.data.data.id;
          if (this.form.is_publish) {
            this.badgeByProduct(productId);
          }
          this.$swal({
            title: 'Created',
            text: `${this.form.name} has been created.`,
            type: 'success',
            timer: 3000,
          });
          this.redirect();
        })
        .catch(error => this.setErrors(error, 'Create'));
    },

    update(data) {
      const route = this.getApiRoute();
      return this.axios.put(`${route}/${this.form.id}`, data)
        .then(() => {
          if (this.form.is_publish) {
            this.badgeByProduct(this.form.id);
          }
          this.$swal({
            title: 'Updated',
            text: `${this.form.name} has been updated.`,
            type: 'success',
            timer: 3000,
          });
          this.redirect();
        })
        .catch(
          error => this.setErrors(error, 'Update'),
        );
    },

    badgeByProduct(productId) {
      return new Promise(async (resolve, reject) => {
        try {
          await this.axios.put(`/badge-product/by-product/${productId}`);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },

    confirmStatusChange(action, data) {
      let swalConf = null;

      if (action === 'approved') {
        swalConf = {
          title: 'Confirmation',
          text: 'Are you sure want to Approved this products?',
          showCancelButton: true,
          confirmButtonColor: '#83A777',
          confirmButtonText: 'Approved',
          cancelButtonText: 'Cancel',
        };
      } else {
        swalConf = {
          title: 'Confirmation',
          text: 'Are you sure want to change this status to Need Revision?',
          showCancelButton: true,
          confirmButtonColor: '#FF6B6B',
          confirmButtonText: 'Need Revision',
          cancelButtonText: 'Cancel',
        };
      }

      this.$swal(swalConf)
      .then((result) => {
        if (result.value) {
          if (action === 'approved') {
            this.updateProductStatus('Approved', data);
          } else {
            this.updateProductStatus('Need Revision', data);
          }
        } else {
          this.isSubmitting = false;
        }
      });

      return false;
    },

    async updateProductStatus(status, data) {
      try {
        const formdata = new FormData();
        formdata.append('status_product', status);
        await this.axios.put(`/products/status/${this.$route.params.id}`, formdata);
        this.update(data);
      } catch (error) {
        this.setErrors(error, 'Update');
      }
    },

    redirect() {
      bus.$emit('destroy-editor');
      this.isSubmitting = false;
      return window.history.length !== 1 ? this.$router.go(-1) : this.$router.push({
        ...this.passRoute,
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' },
      });
    },

    cancel() {
      bus.$emit('destroy-editor');
      return window.history.length !== 1 ? this.$router.go(-1) : this.$router.push({
        ...this.passRoute,
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' },
      });
    },

    handleBookingOptions(checkboxType) {
      setTimeout(() => {
        if (this.form.has_criteria &&
            this.form.has_booking_duration &&
            this.form.has_travel_duration) {
          this.invalidBookingOption(checkboxType);
        }

        if (this.form.has_criteria && this.form.has_travel_duration) {
          this.invalidBookingOption(checkboxType);
        }
      }, 500);
    },

    invalidBookingOption(checkboxType) {
      this.form.has_criteria = false;
      this.form.has_booking_duration = false;
      this.form.has_travel_duration = false;
      if (checkboxType === 'open date') {
        this.form.has_criteria = true;
      } else if (checkboxType === 'booking duration') {
        this.form.has_booking_duration = true;
      } else {
        this.form.has_travel_duration = true;
      }
      this.$swal('Invalid Booking Option', 'Please select valid booking option', 'warning');
    },

    resetField(payload) {
      this.handleBookingOptions(payload);
    },

    setTitle() {
      if (!this.isCreate && this.params.flaging === 'explore') {
        this.title = 'Edit Explore Product';
      } else if (!this.isCreate && this.params.flaging === 'tour') {
        this.title = 'Edit Tour Product';
      } else if (this.isCreate && this.params.flaging === 'explore') {
        this.title = 'Add New Explore Product';
      } else {
        this.title = 'Add New Tour Product';
      }
    },

    setFlagingField() {
      this.setTabTourOnCreate();
      this.setVoucherOnCreated();
      this.form.print_voucher = 0;
    },

    setTabTourOnCreate() {
      if (this.params.flaging === 'tour') {
        this.form.tabs[0].title = 'Informasi Tur';
        this.form.tabs[0].title_en = 'Tour Information';
        this.form.tabs.splice(1, 0,
          {
            title: 'Jadwal Perjalanan',
            title_en: 'Itinerary',
            description: null,
            description_en: null,
          },
        );
      }
    },
    setVoucherOnCreated() {
      if (this.params.flaging === 'explore') {
        this.form.vouchers.push(
          {
            title: 'Instruksi Tiket',
            title_en: 'Ticket Instruction',
            description: null,
            description_en: null,
          },
          {
            title: 'Syarat dan Ketentuan',
            title_en: 'Term and Conditions',
            description: null,
            description_en: null,
          },
        );
      } else {
        this.form.vouchers.push(
          {
            title: 'Jadwal Perjalanan',
            title_en: 'Itinerary',
            description: null,
            description_en: null,
          },
          {
            title: 'Syarat dan Ketentuan',
            title_en: 'Term and Conditions',
            description: null,
            description_en: null,
          },
        );
      }
    },
  },

  created() {
    this.params.flaging = this.$route.query.flaging || null;
    this.setFlagingField();
    this.setTitle();
    this.fetchAll();
  },

  mounted() {
    bus.$on('close-modal', () => {
      this.closeModals();
    });
  },

  destroyed() {
    bus.$off('close-modal');
  },
};
</script>

<style lang="scss" scoped>
  .slideDown-enter-active, .slideDown-leave-active {
    transition: all .5s;
  }
  .slideDown-enter, .slideDown-leave-to {
    top: -50px;
    opacity: 0;
  }

  .ml-2 {
    margin-left: 1rem;
  }

  .mb-2 {
    margin-bottom: 1rem;
  }

  .btn-fat {
    min-height: 10rem;
    margin-top: 2.5rem;
  }

  .need-approval {
    background-color: #d9edf7;
    border-color: #bce8f1;
  }

  .need-revision {
    background-color: #f2dede;
    border-color: #ebccd1;
  }

  .approved {
    background-color: #dff0d8;
    border-color: #d6e9c6;
  }

  .alert-title {
    font-size: 1.6rem;
  }

  .disabled {
    pointer-events:none;
    color: #bfcbd9;
    cursor: not-allowed;
    background-image: none;
    background-color: #eef1f6;
    border-color: #d1dbe5;
  }

  .label {
    padding: 0.325rem 0.5rem;
    cursor: pointer;
  }

  .package-list {
    margin-top: 1rem;

    .panel-package {
      .panel {
        margin-bottom: 1rem;

        &:last-child {
          margin-bottom: 0.75rem;
        }
      }

      .panel-heading {
        padding: 6px 12px;

        .panel-title {
          font-size: 12px;
          font-weight: bold;
          text-transform: uppercase;
        }
      }

      .panel-body {
        padding: 1rem 1.5rem;
      }
    }
  }

  .form-group .row {
    margin-left: 0;
    margin-right: 0;
  }

  .form-control.form-shrink {
    width: calc(100% - 1rem);
  }

  .form-control {
    border-radius: 4px;
  }

  .inline-field-row {
    margin-bottom: 1rem;
    margin-left: -15px !important;
    margin-right: -15px !important;
  }

  .modal .content-wrapper {
    margin-left: 0
  }

  .tab-content {
    width: 100%;

    .form-control {
      border-radius: 0 4px 4px 4px;
    }
  }

  .vdp-datepicker input {
    display: block;
    width: 100%;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
  }

  .v-tabs-content {
    display: block;
    margin: 2rem 0;
  }

  .image-gallery {
    display: flex;
    flex-wrap: wrap;

    .image-item {
      position: relative;
      display: inline-block;
      width: calc(100% / 3 - 1.5rem);
      margin: 0.75rem;
      background: transparent center no-repeat;
      background-size: cover;

      &::after {
        content: '';
        display: block;
        padding-bottom: 100%;
      }
    }
  }

  .quickjump-menu {
    z-index: 5;
    background-color: #ecf0f5;
    width: 100% !important;

    &.affix .quickjump {
      margin-top: 2rem;
    }

    .quickjump {
      margin-bottom: 1rem;
    }

    .flaging-title{
      margin-bottom: 1rem;
    }
  }

  .goto-arrow {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    color: lightseagreen;
    cursor: pointer;
  }

  .time-width{
    width: 282px;
  }

  .time-picker{
    width:100% !important;
  }

  /deep/ .v-timepicker .display-time {
    width:100% !important;
  }

  .group-width{
    width: 100%;
    padding-right: 10px;
  }

  .input-width{
    width: 80%;
  }

  .select-width{
    width: 20%;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/products/Form.vue